var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _polygon, _polygon2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccessDenied(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-4"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 425.75,
    cy: 143.5,
    r: 44.03,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.75,188a44.54,44.54,0,1,1,44.53-44.53A44.59,44.59,0,0,1,425.75,188Zm0-88.07a43.54,43.54,0,1,0,43.53,43.54A43.59,43.59,0,0,0,425.75,100Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.59,140.35a3.09,3.09,0,0,0-4.93-.71,10.91,10.91,0,0,0-1.63,2.89c-1.1,2.57-2.11,5.19-3.2,7.77-.11.28-.47.46-.72.68-.15-.29-.43-.58-.44-.88-.07-1.54-.1-3.08-.1-4.62,0-3,0-6,.05-9.07,0-5.09,0-10.17,0-15.26a3.05,3.05,0,0,0-.52-1.62,3,3,0,0,0-3.35-.92,2.79,2.79,0,0,0-1.77,2.7q0,8.1,0,16.18a2.06,2.06,0,0,1,0,.75.77.77,0,0,1-.53.44c-.18,0-.43-.24-.52-.43a2.07,2.07,0,0,1,0-.75V118.71a11.55,11.55,0,0,0,0-1.18,2.19,2.19,0,0,0-1.8-2.06,2.88,2.88,0,0,0-3.91,3c0,6.18,0,12.36,0,18.54a4.41,4.41,0,0,1-.05,1.09.67.67,0,0,1-.47.44.72.72,0,0,1-.53-.4,3.69,3.69,0,0,1-.06-1c0-4.95,0-9.89,0-14.84a2.84,2.84,0,0,0-5.67,0c0,5.26,0,10.51,0,15.76a3.13,3.13,0,0,1,0,.92,2.66,2.66,0,0,1-.53.74c-.2-.25-.57-.5-.58-.75,0-1.91,0-3.82,0-5.73s0-4,0-6.07a2.66,2.66,0,0,0-2.92-2.6,2.46,2.46,0,0,0-2.52,2.57q-.17,5.94-.34,11.87h0c0,2.42,0,4.83-.13,7.24a36.4,36.4,0,0,0,1.87,14.17,13,13,0,0,0,9,8.53A18.74,18.74,0,0,0,434,167.49a12.53,12.53,0,0,0,6.45-6.93c2.16-5.92,4.2-11.88,6.21-17.86A3.51,3.51,0,0,0,446.59,140.35Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.23,82.76l-1.27-6A20.12,20.12,0,0,0,48.71,85.6L50,91.71a11.25,11.25,0,0,0-6.91,13l8,35.27a11.26,11.26,0,0,0,13.47,8.5l36.62-8.28a11.26,11.26,0,0,0,8.5-13.46l-8-35.28A11.24,11.24,0,0,0,89.23,82.76Zm-5.84,40.66-9.58,2.16-.07-7.25a6,6,0,1,1,6.31-1.55C81.33,119.31,83.39,123.42,83.39,123.42ZM85,83.66l-30.78,7-1.26-6a15.78,15.78,0,0,1,30.78-7Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.79,44.63,152,40.9a12.89,12.89,0,0,0-24.58-7.8l-1.27,3.8a7.21,7.21,0,0,0-8,4.94l-7,22.1A7.22,7.22,0,0,0,115.88,73l22.94,7.26a7.22,7.22,0,0,0,9.06-4.7l7-22.1A7.22,7.22,0,0,0,150.79,44.63ZM134.41,65.24l-6-1.9,2.31-4a3.84,3.84,0,1,1,4,1.18C134.59,62.31,134.41,65.24,134.41,65.24Zm13.74-21.48-19.29-6.1,1.23-3.7A10.12,10.12,0,0,1,149.39,40Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.91,408.05a12,12,0,0,1,2,9.2A21.2,21.2,0,0,1,424,426c-3.63,5.09-9.76,8.86-15.49,11.36-2.35-6.53.46-14.08,2.13-17.82,2.63-5.91,11-15,15.26-11.51",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.86,449.29a10.29,10.29,0,0,1,7.64-6.92,13.58,13.58,0,0,1,10.32,2.13c1.4.92,2.73,2.22,2.9,3.88a4.39,4.39,0,0,1-2.1,3.92,9,9,0,0,1-4.46,1.24c-5.34.29-10.56-.42-14.3-4.25",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.48,458.85a23.28,23.28,0,0,1,6-6.16,42.72,42.72,0,0,1,4.69-2.89,20.55,20.55,0,0,1,9.7-2.37,14.62,14.62,0,0,1,3,.41,3.34,3.34,0,0,1,1.05.38c0,.12-1.56-.33-4.07-.29a21.94,21.94,0,0,0-9.39,2.5,50.81,50.81,0,0,0-4.64,2.8,20.77,20.77,0,0,0-3.44,2.75A30.23,30.23,0,0,1,396.48,458.85Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.16,415.52a11.2,11.2,0,0,1-.83,1.92c-.57,1.22-1.43,3-2.5,5.12-2.15,4.3-5.18,10.2-8.69,16.64s-6.86,12.19-9.37,16.29c-1.25,2.05-2.28,3.7-3,4.82a11,11,0,0,1-1.2,1.71,13,13,0,0,1,1-1.85l2.83-4.93c2.39-4.17,5.66-9.94,9.17-16.37l8.87-16.54,2.7-5A12.67,12.67,0,0,1,420.16,415.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.8,447.55a24,24,0,0,0-5.89-21.14c-1.32-1.41-3.26-2.75-5.06-2.05s-2.36,3-2.35,4.93a20.52,20.52,0,0,0,13,18.69",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.07,432s.3.26.73.82,1,1.39,1.72,2.45a26.84,26.84,0,0,1,3.89,9.08,17,17,0,0,1,.18,5.48,16.6,16.6,0,0,1-1.25,4.31,15.91,15.91,0,0,1-1.45,2.62c-.41.59-.65.89-.69.87s.77-1.38,1.69-3.68a17.76,17.76,0,0,0,1.05-4.2,17.26,17.26,0,0,0-.22-5.27,30.64,30.64,0,0,0-3.62-9A36.08,36.08,0,0,1,394.07,432Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61,446.2c.59-2.29-.91-4.58-2.59-6.24s-3.69-3.15-4.56-5.34c-1.42-3.55.49-8.15-1.93-11.11-1.42-1.75-4-2.33-5.23-4.19A9.61,9.61,0,0,1,45.53,416a33.66,33.66,0,0,0-8.41-15.73,29.47,29.47,0,0,0,3.3,15.16c1,1.86,2.18,3.68,2.51,5.76.52,3.38-1.36,6.85-.53,10.17,1,3.79,5.21,6.33,5.41,10.23.17,3.3-2.71,6.2-2.49,9.5A8.81,8.81,0,0,0,46.79,455c2.55,4.24,6.3,7.16,12,7.07l7,.24Z",
    style: {
      fill: "#0072BC"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61,446.2c.59-2.29-.91-4.58-2.59-6.24s-3.69-3.15-4.56-5.34c-1.42-3.55.49-8.15-1.93-11.11-1.42-1.75-4-2.33-5.23-4.19A9.61,9.61,0,0,1,45.53,416a33.66,33.66,0,0,0-8.41-15.73,29.47,29.47,0,0,0,3.3,15.16c1,1.86,2.18,3.68,2.51,5.76.52,3.38-1.36,6.85-.53,10.17,1,3.79,5.21,6.33,5.41,10.23.17,3.3-2.71,6.2-2.49,9.5A8.81,8.81,0,0,0,46.79,455c2.55,4.24,6.3,7.16,12,7.07l7,.24Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M67.14,462.49a5.56,5.56,0,0,0,1.91-.05,11.53,11.53,0,0,0,2.26-.56,9.78,9.78,0,0,0,2.8-1.53,3.91,3.91,0,0,0,1.14-1.54,7,7,0,0,0,.33-2.07,22.24,22.24,0,0,1,.16-2.26,6.3,6.3,0,0,1,.85-2.23c.83-1.44,2.19-2.81,2.63-4.77a16,16,0,0,0-.19-6.1,12.93,12.93,0,0,1,.16-6.53c.75-2.18,2.27-4.15,3-6.6s.4-5.14.56-7.77a10.38,10.38,0,0,1,.91-3.86c.56-1.24,1.34-2.4,2-3.69,1.24-2.63,1.46-5.6,1.79-8.51.17-1.47.34-2.95.5-4.45a21.73,21.73,0,0,1,.78-4.45,39.66,39.66,0,0,1,1.66-4.3,15,15,0,0,0,.81-2.25,21.84,21.84,0,0,0,.22-2.4,27.69,27.69,0,0,0-.18-4.81c-.19-1.61-.48-3.2-.65-4.81l0-.28,0-.32-.29.14a10.73,10.73,0,0,0-3.74,3.17,16.78,16.78,0,0,0-2.3,4.24A51.91,51.91,0,0,0,82,393a24.83,24.83,0,0,1-2.86,8.42c-.76,1.24-1.68,2.37-2.49,3.58a9.76,9.76,0,0,0-1.73,4c-.41,2.95,1.21,5.53.87,8.14a9,9,0,0,1-1.27,3.61c-.63,1.11-1.37,2.14-2.08,3.18a20.72,20.72,0,0,0-1.86,3.21,10.11,10.11,0,0,0-.86,3.49c-.17,2.35.17,4.57,0,6.67A15.4,15.4,0,0,1,68,443c-.85,1.71-1.78,3.26-2.57,4.76-.39.75-.75,1.49-1,2.22a10.53,10.53,0,0,0-.61,2.2,13.63,13.63,0,0,0-.05,4,10,10,0,0,0,2,5.07,4.26,4.26,0,0,0,.56.61,3.55,3.55,0,0,0,.46.39l.4.28a8.94,8.94,0,0,1-1.35-1.34,10,10,0,0,1-1.89-5,13.66,13.66,0,0,1,.09-3.91,10.38,10.38,0,0,1,.61-2.15c.3-.72.67-1.45,1.06-2.19.79-1.49,1.74-3,2.6-4.75A15.8,15.8,0,0,0,70,437.3c.18-2.15-.14-4.38,0-6.67a9.87,9.87,0,0,1,.83-3.38,21.49,21.49,0,0,1,1.85-3.14c.71-1,1.46-2.07,2.11-3.2a9.39,9.39,0,0,0,1.32-3.76c.34-2.78-1.27-5.38-.85-8.12A9.37,9.37,0,0,1,77,405.24c.79-1.19,1.72-2.32,2.5-3.59a25,25,0,0,0,2.93-8.56,52.2,52.2,0,0,1,2.15-9,16.7,16.7,0,0,1,2.24-4.13,10.3,10.3,0,0,1,3.59-3l-.32-.18,0,.28c.18,1.63.47,3.22.65,4.81a26.94,26.94,0,0,1,.19,4.74c0,.78-.09,1.59-.21,2.32A13.45,13.45,0,0,1,90,391a39.11,39.11,0,0,0-1.67,4.36,22.32,22.32,0,0,0-.79,4.52c-.16,1.5-.33,3-.49,4.45-.33,2.93-.55,5.85-1.74,8.38-.59,1.26-1.37,2.43-2,3.7a10.66,10.66,0,0,0-.93,4c-.15,2.69.2,5.32-.53,7.69s-2.24,4.35-3,6.59a13.06,13.06,0,0,0-.15,6.7,15.67,15.67,0,0,1,.22,6c-.4,1.87-1.72,3.22-2.56,4.7a6.28,6.28,0,0,0-.86,2.33,18.17,18.17,0,0,0-.15,2.28,7.19,7.19,0,0,1-.3,2A3.7,3.7,0,0,1,74,460.21a9.48,9.48,0,0,1-2.72,1.54,13,13,0,0,1-2.23.61,9.15,9.15,0,0,1-1.42.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.12,380.5a1.26,1.26,0,0,0-.06.21c0,.17-.1.38-.16.63-.13.55-.3,1.38-.56,2.41s-.9,2.2-1.44,3.63a49,49,0,0,0-1.66,4.94c-.53,1.86-1,3.92-1.49,6.12a26,26,0,0,1-2.23,6.8c-.57,1.13-1.21,2.28-1.72,3.53a16.21,16.21,0,0,0-1,4,82,82,0,0,1-1.5,8.42c-1.4,5.7-2.73,11.13-3.94,16.08l-3.3,13.11c-.91,3.71-1.66,6.73-2.18,8.86-.24,1-.44,1.82-.57,2.41-.06.25-.11.46-.14.63a.6.6,0,0,0,0,.22,2,2,0,0,0,.07-.21l.18-.62.66-2.39c.55-2.12,1.35-5.12,2.32-8.82s2.12-8.17,3.39-13.09,2.56-10.38,4-16.08a80.53,80.53,0,0,0,1.5-8.46,15.94,15.94,0,0,1,1-3.89c.5-1.22,1.13-2.36,1.7-3.5a26.22,26.22,0,0,0,2.22-6.9c.48-2.22.93-4.27,1.44-6.12s1-3.51,1.58-4.94,1.12-2.61,1.38-3.67.37-1.88.48-2.44c.05-.26.08-.47.11-.64A.72.72,0,0,0,89.12,380.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.36,462.51c4.55-2.7,5.85-10.91,4-15.84S67.1,437.22,66.59,432c-.39-4,.93-8.2,0-12.15-1.27-5.34-6.48-9.47-6.42-15,0-3.08,1.78-6,1.64-9.05-.17-3.77-3.06-6.76-4.86-10.08-2.74-5.09-2.92-11.1-3.86-16.8S50,357.11,44.92,354.31c-.75,4.84-2,8.15-1.62,14.71.14,2.36,2.88,6.86,3.25,12,.22,3.08.38,6.17.56,9.26a29.8,29.8,0,0,0,1.46,8.87c.82,2.16,2.15,4.11,2.76,6.34,1.16,4.18-.36,8.71.57,13,.79,3.59,3.28,6.68,3.78,10.33.72,5.11-2.59,10.43-.9,15.31.84,2.42,2.83,4.36,3.4,6.87.44,1.94,0,4,.36,5.94.64,3.14,6.63,5.58,9.82,5.38",
    style: {
      fill: "#0072BC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.17,359.11a1.1,1.1,0,0,0,0,.27c0,.21.06.47.1.8.11.7.22,1.73.46,3.05s.94,2.84,1.49,4.65,1.16,3.89,1.67,6.23,1,4.91,1.41,7.69a32.21,32.21,0,0,0,2.33,8.7c.63,1.45,1.35,2.9,1.89,4.45a19.87,19.87,0,0,1,1,4.91,100.86,100.86,0,0,0,1.34,10.59c1.39,7.18,2.72,14,3.92,20.23s2.42,11.77,3.39,16.47l2.31,11.1.66,3q.11.48.18.78a2.18,2.18,0,0,0,.07.26.93.93,0,0,0,0-.27c0-.2-.08-.46-.13-.79-.14-.72-.33-1.74-.57-3-.53-2.66-1.27-6.45-2.18-11.12s-2.06-10.29-3.29-16.5-2.51-13-3.89-20.21a100,100,0,0,1-1.34-10.56,20.51,20.51,0,0,0-1-5c-.55-1.58-1.28-3-1.92-4.48a32.14,32.14,0,0,1-2.34-8.59c-.47-2.78-.92-5.36-1.46-7.7s-1.14-4.43-1.74-6.23-1.29-3.31-1.56-4.61-.41-2.34-.54-3c-.06-.33-.11-.59-.15-.79A1,1,0,0,0,46.17,359.11Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 140.19,
    y: 80.02,
    width: 266.62,
    height: 382.62,
    rx: 11.55,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.6,
    y: 106.2,
    width: 249.81,
    height: 319.54,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 273.5,
    cy: 443.42,
    r: 10.23,
    transform: "translate(-221.06 607.21) rotate(-76.66)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.35,
    y: 91.04,
    width: 80.3,
    height: 4.23,
    rx: 1.22,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.8,400H242.21a13.43,13.43,0,0,1-13.43-13.43h0a13.43,13.43,0,0,1,13.43-13.43H304.8a13.43,13.43,0,0,1,13.43,13.43h0A13.43,13.43,0,0,1,304.8,400Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.6,388.21l.24-.48a2.71,2.71,0,0,0,1.86.72c1.06,0,1.53-.45,1.53-1,0-1.62-3.48-.64-3.47-2.83,0-.87.65-1.62,2.09-1.61a3.07,3.07,0,0,1,1.75.53l-.2.5a2.76,2.76,0,0,0-1.55-.5c-1,0-1.5.47-1.5,1.07,0,1.62,3.48.65,3.47,2.8,0,.87-.67,1.61-2.12,1.61A3,3,0,0,1,256.6,388.21Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.14,383h.59l0,5.91h-.6Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.3,383.08l0,5.91h-.49l-3.62-4.81,0,4.8h-.6l0-5.91h.49l3.62,4.81,0-4.8Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.12,386.06h.57v2.25a3,3,0,0,1-2.08.75,3,3,0,0,1,0-6,2.7,2.7,0,0,1,2.09.86l-.37.39a2.29,2.29,0,0,0-1.7-.7,2.45,2.45,0,1,0,1.45,4.45Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.45,386.51v-3.39h.6l0,3.36c0,1.4.63,2,1.73,2.05s1.74-.64,1.74-2l0-3.36h.58l0,3.38c0,1.7-.88,2.57-2.33,2.56S279.44,388.21,279.45,386.51Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.33,385.2c0,1.26-.88,2-2.32,2h-1.52v1.87h-.6l0-5.91H288C289.46,383.17,290.33,383.93,290.33,385.2Zm-.6,0c0-.95-.59-1.49-1.72-1.5H286.5v2.95H288C289.13,386.66,289.73,386.13,289.73,385.2Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.56,
    y: 253.06,
    width: 35.64,
    height: 6.54,
    transform: "matrix(1, 0, 0, 1, 1.19, -1.01)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.06,293.26a5.67,5.67,0,0,0,.82-.15,2.89,2.89,0,0,0,1.75-1.57,3.75,3.75,0,0,0,.24-1.76c0-.67,0-1.41,0-2.2,0-1.6,0-3.43,0-5.5v-8.8a3,3,0,0,0-.4-1.83,2.81,2.81,0,0,0-1.51-1.17,8.82,8.82,0,0,0-2.09-.12l-20,0-115.5-.42a2.55,2.55,0,0,0-2.53,2.23c0,1.31,0,2.77,0,4.15,0,2.78,0,5.55,0,8.29,0,1.38,0,2.74,0,4.11a8,8,0,0,0,.09,1.93,2.51,2.51,0,0,0,1,1.42,2.78,2.78,0,0,0,1.72.45h2l4,0,30.67.16,51.92.32,35,.27,9.52.11,2.47.05.85,0s-.29,0-.85,0l-2.47,0-9.52,0-35,0-51.93-.17L211.62,293h-6a3.54,3.54,0,0,1-2.13-.57,3.28,3.28,0,0,1-1.29-1.82,8.73,8.73,0,0,1-.12-2.13c0-1.36,0-2.73,0-4.1,0-2.75,0-5.51,0-8.3,0-1.41,0-2.75,0-4.23A3.26,3.26,0,0,1,205.4,269l115.5.63,20,.15a8.75,8.75,0,0,1,2.21.15,3.14,3.14,0,0,1,1.71,1.34,3.45,3.45,0,0,1,.44,2c0,.66,0,1.3,0,1.93,0,2.51,0,4.81-.06,6.88s0,3.89-.05,5.49c0,.79,0,1.53,0,2.2a3.93,3.93,0,0,1-.29,1.82,2.91,2.91,0,0,1-1.86,1.58A2.33,2.33,0,0,1,342.06,293.26Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.29,
    y: 315.3,
    width: 35.64,
    height: 6.54,
    transform: "translate(1.47 -1.01) rotate(0.26)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.79,355.5a5.42,5.42,0,0,0,.82-.15,2.9,2.9,0,0,0,1.76-1.58,3.84,3.84,0,0,0,.24-1.75c0-.68,0-1.41,0-2.2,0-1.6,0-3.43,0-5.5v-8.8a3,3,0,0,0-.41-1.83,2.71,2.71,0,0,0-1.5-1.17,8.87,8.87,0,0,0-2.1-.12l-19.94,0-115.5-.43a2.54,2.54,0,0,0-2.53,2.23c-.05,1.32,0,2.78,0,4.15,0,2.79,0,5.55,0,8.3,0,1.37,0,2.74,0,4.1a8.66,8.66,0,0,0,.08,1.94,2.59,2.59,0,0,0,1,1.42,2.74,2.74,0,0,0,1.73.44h2l4,0,30.66.17L294,355l35,.28,9.51.11,2.48,0c.56,0,.84,0,.84,0l-.84,0-2.48,0-9.52,0-35-.05L242,355.37l-30.67-.12-4,0h-2a3.43,3.43,0,0,1-2.12-.56,3.28,3.28,0,0,1-1.3-1.82,9.23,9.23,0,0,1-.11-2.13c0-1.36,0-2.73,0-4.1q0-4.12,0-8.3c0-1.41,0-2.75,0-4.23a3.27,3.27,0,0,1,3.25-2.87l115.5.64,19.95.15a8.68,8.68,0,0,1,2.2.15,3.07,3.07,0,0,1,1.71,1.34,3.38,3.38,0,0,1,.45,2c0,.65,0,1.3,0,1.92,0,2.52,0,4.82-.06,6.88s0,3.9-.06,5.5c0,.79,0,1.52,0,2.2a3.88,3.88,0,0,1-.29,1.81,2.94,2.94,0,0,1-1.87,1.59A2.33,2.33,0,0,1,341.79,355.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.12,
    y: 278.28,
    width: 65.19,
    height: 6.11,
    transform: "translate(1.3 -1.13) rotate(0.26)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.06,344.19a2.86,2.86,0,1,1-2.84-3.06A2.94,2.94,0,0,1,218.06,344.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.89,344.23a2.86,2.86,0,1,1-2.84-3.05A2.94,2.94,0,0,1,226.89,344.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.72,344.27a2.86,2.86,0,1,1-2.84-3A2.94,2.94,0,0,1,235.72,344.27Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.55,344.31a2.86,2.86,0,1,1-2.84-3.05A3,3,0,0,1,244.55,344.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.38,344.35a2.86,2.86,0,1,1-2.84-3.05A3,3,0,0,1,253.38,344.35Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.21,344.39a2.86,2.86,0,1,1-2.84-3.05A3,3,0,0,1,262.21,344.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271,344.43a2.86,2.86,0,1,1-2.84-3.05A3,3,0,0,1,271,344.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.87,344.47a2.86,2.86,0,1,1-2.83-3.05A2.94,2.94,0,0,1,279.87,344.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.7,344.51a2.86,2.86,0,1,1-2.83-3.05A2.94,2.94,0,0,1,288.7,344.51Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 279.8,
    cy: 181.75,
    r: 48.88,
    transform: "translate(-46.57 251.08) rotate(-45)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.58,182.44a10.7,10.7,0,0,0,6.37-9.9c0-5.91-4.45-10.72-10-10.74s-10,4.74-10.07,10.65a10.69,10.69,0,0,0,6.39,10c-15.44,2.32-14.74,19.1-14.74,19.1l36.51.17S298.88,184.75,283.58,182.44Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Sign--inject-4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 103.83,
    y: 229.31,
    width: 12.88,
    height: 233.26,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.25,
    y: 229.31,
    width: 12.88,
    height: 233.26,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.77,206.92c0-8.77,0-17.54,0-26.3a3.4,3.4,0,0,0-.78-2.18Q154.3,159.69,135.53,141a4.19,4.19,0,0,0-2.7-1.08c-17.32-.06-34.63,0-51.94-.08a4.2,4.2,0,0,0-3.27,1.42q-18.37,18.45-36.79,36.87a4,4,0,0,0-1,2.55q-.09,26.22,0,52.44a4,4,0,0,0,1.07,2.53q18.36,18.48,36.79,36.89A4.15,4.15,0,0,0,80.92,274q25.8-.06,51.61,0a4.25,4.25,0,0,0,3.3-1.35c12.24-12.31,24.55-24.56,36.78-36.88a4.25,4.25,0,0,0,1.11-2.69C173.8,224.34,173.77,215.63,173.77,206.92Z",
    style: {
      fill: "#0072BC"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--4mamg4tif--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.14,206.76c0-10,0-20.06,0-30.08a3.82,3.82,0,0,1,1-2.42q16.72-16.83,33.55-33.59c3.06-3.06,6.07-6.16,9.19-9.15a4.07,4.07,0,0,1,2.52-1.1c20.06-.06,40.11,0,60.17-.07a4.05,4.05,0,0,1,3.15,1.32q21.21,21.3,42.49,42.55a3.72,3.72,0,0,1,1,2.39c.05,20.17,0,40.33.05,60.5a3.47,3.47,0,0,1-1.13,2.72Q165.47,256.4,148.89,273c-3.17,3.17-6.35,6.34-9.6,9.44a3.62,3.62,0,0,1-2.24.95q-30.42.07-60.83,0a3.29,3.29,0,0,1-2.11-.86q-17.78-17.65-35.47-35.39c-2.48-2.47-5-4.91-7.39-7.47a4.13,4.13,0,0,1-1.06-2.54C30.12,227,30.14,216.9,30.14,206.76Zm76.64-71.91c-9.53,0-19.07,0-28.6,0a3.12,3.12,0,0,0-2,.72q-20.32,20.21-40.53,40.53a3.8,3.8,0,0,0-1,2.42q-.08,28.35,0,56.71a3.94,3.94,0,0,0,1,2.54q20,20.14,40.2,40.17a3.77,3.77,0,0,0,2.41,1c18.84.05,37.69,0,56.54.07a3.68,3.68,0,0,0,2.87-1.19q19.89-19.95,39.85-39.85a3.86,3.86,0,0,0,1.2-3c0-18.85,0-37.7-.06-56.55a3.67,3.67,0,0,0-.94-2.26c-3.5-3.62-7.09-7.15-10.65-10.72q-14.52-14.53-29-29.09a4.77,4.77,0,0,0-3.73-1.53C125.19,134.89,116,134.85,106.78,134.85Z",
    style: {
      fill: "#0072BC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.78,134.85c9.21,0,18.41,0,27.62,0a4.77,4.77,0,0,1,3.73,1.53q14.48,14.58,29,29.09c3.56,3.57,7.15,7.1,10.65,10.72a3.67,3.67,0,0,1,.94,2.26c.05,18.85,0,37.7.06,56.55a3.86,3.86,0,0,1-1.2,3q-20,19.89-39.85,39.85a3.68,3.68,0,0,1-2.87,1.19c-18.85,0-37.7,0-56.54-.07a3.77,3.77,0,0,1-2.41-1q-20.16-20-40.2-40.17a3.94,3.94,0,0,1-1-2.54q-.09-28.37,0-56.71a3.8,3.8,0,0,1,1-2.42q20.2-20.32,40.53-40.53a3.12,3.12,0,0,1,2-.72C87.71,134.83,97.25,134.85,106.78,134.85Zm66.93,72.07c0-8.77,0-17.54,0-26.3a3.4,3.4,0,0,0-.78-2.18q-18.65-18.75-37.43-37.4a4.19,4.19,0,0,0-2.7-1.08c-17.31-.06-34.63,0-51.94-.08a4.19,4.19,0,0,0-3.26,1.42q-18.39,18.45-36.8,36.87a4,4,0,0,0-1,2.55q-.09,26.22,0,52.44a4,4,0,0,0,1.07,2.53q18.36,18.48,36.79,36.89A4.16,4.16,0,0,0,80.86,274q25.81-.06,51.61,0a4.24,4.24,0,0,0,3.3-1.35c12.25-12.31,24.55-24.56,36.79-36.88a4.24,4.24,0,0,0,1.1-2.69C173.74,224.34,173.71,215.63,173.71,206.92Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M95.21,214.16H89.55v7.3H81.71v-7.3H63v-5.41l16.38-22h8.43l-15.18,20.9H82v-6.5h7.59v6.5h5.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.59,204.09c0-11.47,6.35-18,14.89-18s14.89,6.5,14.89,18-6.3,18-14.89,18S97.59,215.55,97.59,204.09Zm21.69,0c0-7.89-2.78-11.17-6.8-11.17s-6.75,3.28-6.75,11.17,2.78,11.17,6.75,11.17S119.28,212,119.28,204.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.39,186.71v34.75h-8V193.17H129.4v-6.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98,176v1.5H89.28v-12h8.48v1.49H91v3.69h6v1.46H91V176Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.44,168.27v1.6a2.55,2.55,0,0,0-.38,0c-1.76,0-2.86,1.08-2.86,3.07v4.54h-1.65v-9.1h1.58v1.52A3.47,3.47,0,0,1,105.44,168.27Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.37,168.27v1.6a2.55,2.55,0,0,0-.38,0c-1.77,0-2.87,1.08-2.87,3.07v4.54h-1.65v-9.1h1.58v1.52A3.48,3.48,0,0,1,112.37,168.27Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.47,172.91a4.73,4.73,0,1,1,4.74,4.65A4.53,4.53,0,0,1,113.47,172.91Zm7.79,0a3.07,3.07,0,1,0-6.13,0,3.07,3.07,0,1,0,6.13,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.11,168.27v1.6a2.42,2.42,0,0,0-.37,0c-1.77,0-2.87,1.08-2.87,3.07v4.54h-1.65v-9.1h1.58v1.52A3.48,3.48,0,0,1,130.11,168.27Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.24,235.59v-5.34h1.34v5.28c0,2.08,1,3,2.64,3s2.66-.94,2.66-3v-5.28h1.3v5.34c0,2.72-1.49,4.16-4,4.16S62.24,238.31,62.24,235.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.49,235.55v4.09H78.2v-3.95c0-1.39-.7-2.07-1.92-2.07A2.1,2.1,0,0,0,74,236v3.66H72.74v-7.11H74v1.07a3.08,3.08,0,0,1,2.57-1.14A2.75,2.75,0,0,1,79.49,235.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.51,235.35v4.29H86.29v-.94a2.65,2.65,0,0,1-2.34,1c-1.61,0-2.63-.86-2.63-2.09s.74-2.08,2.86-2.08h2v-.26c0-1.08-.63-1.72-1.91-1.72a3.6,3.6,0,0,0-2.25.77l-.54-1a4.75,4.75,0,0,1,2.94-.91C86.41,232.46,87.51,233.4,87.51,235.35Zm-1.29,2.12v-1h-2c-1.27,0-1.63.5-1.63,1.1s.59,1.16,1.57,1.16A2.07,2.07,0,0,0,86.22,237.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.52,232.53v7.11H95.3v-1.07a2.92,2.92,0,0,1-2.42,1.15,2.8,2.8,0,0,1-3.06-3.1v-4.09h1.29v3.94c0,1.4.7,2.1,1.92,2.1a2.1,2.1,0,0,0,2.2-2.37v-3.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103,239.22a2.41,2.41,0,0,1-1.56.5,2,2,0,0,1-2.25-2.23v-3.9H98v-1.06h1.21V231h1.29v1.56h2v1.06h-2v3.85a1,1,0,0,0,1.11,1.19,1.62,1.62,0,0,0,1-.33Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.27,235.55v4.09H110v-3.95c0-1.39-.7-2.07-1.92-2.07a2.1,2.1,0,0,0-2.25,2.36v3.66h-1.29v-10h1.29v3.85a3.1,3.1,0,0,1,2.51-1.07A2.75,2.75,0,0,1,111.27,235.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113,236.08a3.7,3.7,0,1,1,3.7,3.64A3.54,3.54,0,0,1,113,236.08Zm6.09,0a2.4,2.4,0,1,0-2.39,2.51A2.33,2.33,0,0,0,119.13,236.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126,232.46v1.25h-.29a2.12,2.12,0,0,0-2.24,2.4v3.54h-1.29v-7.11h1.23v1.19A2.72,2.72,0,0,1,126,232.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.39,230.33a.87.87,0,1,1,.87.83A.83.83,0,0,1,127.39,230.33Zm.22,2.2h1.29v7.11h-1.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.63,238.58v1.06h-6v-.83l4.2-5.22h-4.12v-1.06h5.77v.84l-4.2,5.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.63,236.51h-5.77a2.42,2.42,0,0,0,2.58,2.08,2.64,2.64,0,0,0,2.05-.86l.71.84a3.87,3.87,0,0,1-6.62-2.49,3.48,3.48,0,0,1,3.57-3.62,3.43,3.43,0,0,1,3.51,3.66A2.66,2.66,0,0,1,144.63,236.51Zm-5.77-.92h4.57a2.3,2.3,0,0,0-4.57,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.15,229.68v10h-1.23v-1.13a3,3,0,0,1-2.54,1.21,3.63,3.63,0,0,1,0-7.26,3,3,0,0,1,2.48,1.14v-3.92Zm-1.28,6.4a2.39,2.39,0,1,0-2.38,2.51A2.34,2.34,0,0,0,151.87,236.08Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Padlock--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M325.32,238.6a13.51,13.51,0,0,0-18.15-6l-18.34,9.24a13.51,13.51,0,0,0-6,18.14h0A13.51,13.51,0,0,0,301,266l18.34-9.24A13.52,13.52,0,0,0,325.32,238.6Zm-8.75,12.48-18.2,9.17a7.2,7.2,0,1,1-6.48-12.87l18.2-9.17a7.2,7.2,0,1,1,6.48,12.87Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.8,239l6-2.79a12.63,12.63,0,0,0-1.48-1.56L316.15,238S317.64,238.54,317.8,239Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.33,246.5l6.34-.11a27.45,27.45,0,0,0-.06-3.75l-6.13,2.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.32,238.6a13.51,13.51,0,0,0-18.15-6l-18.34,9.24a13.51,13.51,0,0,0-6,18.14h0A13.51,13.51,0,0,0,301,266l18.34-9.24A13.52,13.52,0,0,0,325.32,238.6Zm-8.75,12.48-18.2,9.17a7.2,7.2,0,1,1-6.48-12.87l18.2-9.17a7.2,7.2,0,1,1,6.48,12.87Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.57,251.08a8.5,8.5,0,0,0,2.48-2.23,7.19,7.19,0,0,0,1.31-3.61,7,7,0,0,0-10.06-6.88l-3.35,1.7L292,247.61a7,7,0,0,0-3.79,6.89,7.06,7.06,0,0,0,1.46,3.64,6.94,6.94,0,0,0,3.06,2.21,7.1,7.1,0,0,0,3.58.34,11.51,11.51,0,0,0,3.22-1.27l5.7-2.84,8.27-4.07,2.26-1.08a4.49,4.49,0,0,1,.8-.35,5.65,5.65,0,0,1-.75.44l-2.22,1.17-8.2,4.22-5.67,2.89a11.62,11.62,0,0,1-3.33,1.34,7.52,7.52,0,0,1-3.83-.35,7.45,7.45,0,0,1-4-10.51,7.52,7.52,0,0,1,3.21-3.13l15-7.52L310.1,238a7.36,7.36,0,0,1,9.13,2.25,7.3,7.3,0,0,1,1.42,5,7.17,7.17,0,0,1-1.44,3.71,7,7,0,0,1-1.86,1.71,5.16,5.16,0,0,1-.57.31Q316.58,251.1,316.57,251.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.32,238.6a1.71,1.71,0,0,1,.15.29c.11.22.24.51.41.87s.33.88.51,1.47a14.24,14.24,0,0,1,.39,2.09,13.73,13.73,0,0,1-.61,5.78,14.68,14.68,0,0,1-1.62,3.28,14.48,14.48,0,0,1-2.77,3,22.39,22.39,0,0,1-3.88,2.29l-4.32,2.2L304,264.72a35.15,35.15,0,0,1-5.3,2.41,13.38,13.38,0,0,1-6.08.36,13.66,13.66,0,0,1-5.83-2.43,13.66,13.66,0,0,1-5.68-11.27,13.69,13.69,0,0,1,1.52-6.13,13.26,13.26,0,0,1,3.91-4.67,35.22,35.22,0,0,1,5.09-2.83l9.56-4.79,4.34-2.17a22,22,0,0,1,4.14-1.75,15,15,0,0,1,4.08-.43,14.76,14.76,0,0,1,3.6.66,13.6,13.6,0,0,1,5,2.94,14.28,14.28,0,0,1,1.45,1.56c.36.5.66.93.88,1.29l.45.84a1.56,1.56,0,0,1,.14.29,15.83,15.83,0,0,0-3.05-3.83,13.51,13.51,0,0,0-5-2.82,14.22,14.22,0,0,0-3.52-.6,14.54,14.54,0,0,0-4,.45,21.51,21.51,0,0,0-4.06,1.76l-4.33,2.19-9.54,4.84a34.68,34.68,0,0,0-5,2.79,12.87,12.87,0,0,0-3.75,4.51,13.1,13.1,0,0,0-1.46,5.9,13.19,13.19,0,0,0,5.47,10.86,13.19,13.19,0,0,0,5.61,2.34,13,13,0,0,0,5.86-.33,34.67,34.67,0,0,0,5.22-2.36l9.57-4.79,4.33-2.17a21.38,21.38,0,0,0,3.83-2.22,13.36,13.36,0,0,0,4.34-6.11,13.53,13.53,0,0,0,.69-5.67A15.63,15.63,0,0,0,325.32,238.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.92,209.64a13.5,13.5,0,0,0-18.14-6l-18.34,9.24a13.51,13.51,0,0,0-6,18.15h0a13.51,13.51,0,0,0,18.14,6l18.35-9.24A13.5,13.5,0,0,0,383.92,209.64Zm-8.74,12.47L357,231.28a7.21,7.21,0,1,1-6.49-12.87l18.2-9.17a7.21,7.21,0,0,1,6.49,12.87Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.4,210l6-2.8a13.33,13.33,0,0,0-1.47-1.55l-6.14,3.37S376.24,209.57,376.4,210Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.93,217.54l6.34-.11a27.18,27.18,0,0,0,0-3.76l-6.13,2.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.92,209.64a13.5,13.5,0,0,0-18.14-6l-18.34,9.24a13.51,13.51,0,0,0-6,18.15h0a13.51,13.51,0,0,0,18.14,6l18.35-9.24A13.5,13.5,0,0,0,383.92,209.64Zm-8.74,12.47L357,231.28a7.21,7.21,0,1,1-6.49-12.87l18.2-9.17a7.21,7.21,0,0,1,6.49,12.87Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.18,222.11a8.59,8.59,0,0,0,2.47-2.22,7,7,0,0,0-8.75-10.49l-3.35,1.69-14.94,7.55a7,7,0,0,0-3.79,6.89,7.1,7.1,0,0,0,1.47,3.65,7,7,0,0,0,3,2.2,6.89,6.89,0,0,0,3.58.34,11,11,0,0,0,3.23-1.27l5.7-2.83,8.26-4.08,2.26-1.08a7.33,7.33,0,0,1,.81-.35,4.43,4.43,0,0,1-.76.44l-2.22,1.17L364,227.94l-5.67,2.89a11.57,11.57,0,0,1-3.34,1.34,7.48,7.48,0,0,1-3.82-.34,7.45,7.45,0,0,1-.8-13.65l15-7.51,3.37-1.68a7.51,7.51,0,0,1,3.54-.72,7.39,7.39,0,0,1,5.59,3,7.31,7.31,0,0,1,1.41,5.06,7.24,7.24,0,0,1-1.44,3.71,7,7,0,0,1-1.85,1.7,5.11,5.11,0,0,1-.58.31C375.25,222.09,375.18,222.12,375.18,222.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.92,209.64s.06.09.16.28l.41.87q.22.59.51,1.47a14.14,14.14,0,0,1,.39,2.1,13.55,13.55,0,0,1-.62,5.77,14.21,14.21,0,0,1-1.61,3.28,14.54,14.54,0,0,1-2.78,3,21.34,21.34,0,0,1-3.87,2.29l-4.32,2.2-9.55,4.83a33.76,33.76,0,0,1-5.3,2.41,13.38,13.38,0,0,1-6.08.36,13.55,13.55,0,0,1-5.82-2.42,14.07,14.07,0,0,1-4.22-4.95,13.92,13.92,0,0,1-1.46-6.33,13.6,13.6,0,0,1,1.51-6.12,13.42,13.42,0,0,1,3.91-4.68,34.72,34.72,0,0,1,5.09-2.82l9.57-4.8,4.33-2.16a21.73,21.73,0,0,1,4.15-1.75,14.55,14.55,0,0,1,4.08-.43,14.22,14.22,0,0,1,3.59.65,13.65,13.65,0,0,1,5,2.94,15.06,15.06,0,0,1,1.44,1.56c.37.5.66.93.89,1.29l.45.84a.94.94,0,0,1,.13.3,15.11,15.11,0,0,0-3.05-3.84,13.68,13.68,0,0,0-5-2.82,14.3,14.3,0,0,0-3.52-.6,14.68,14.68,0,0,0-4,.46,21.09,21.09,0,0,0-4.06,1.75L360,206.78l-9.55,4.84a34.58,34.58,0,0,0-5,2.79,13,13,0,0,0-3.76,4.51,13.16,13.16,0,0,0-1.45,5.91,13.19,13.19,0,0,0,5.47,10.85,13,13,0,0,0,5.61,2.34,12.85,12.85,0,0,0,5.86-.33,34.58,34.58,0,0,0,5.22-2.36l9.56-4.79,4.34-2.17a21.73,21.73,0,0,0,3.83-2.22,14.93,14.93,0,0,0,2.73-2.92A14.49,14.49,0,0,0,384.5,220a13.5,13.5,0,0,0,.69-5.66A15.53,15.53,0,0,0,383.92,209.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.5,202.77l-31.32,14.66a3.51,3.51,0,0,1-4.68-1.69h0a3.52,3.52,0,0,1,1.7-4.68l31.31-14.67a3.52,3.52,0,0,1,4.68,1.7h0A3.51,3.51,0,0,1,408.5,202.77Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.5,202.77s.29-.15.74-.54a3.44,3.44,0,0,0-.65-5.63,3.38,3.38,0,0,0-2.44-.26,8.18,8.18,0,0,0-1.29.55l-1.36.65-29.19,13.75a3.27,3.27,0,0,0,1.09,6.21,3.51,3.51,0,0,0,2-.44l2-.92,3.8-1.77,13.16-6.1,8.89-4.07,2.43-1.09.63-.27a.9.9,0,0,1,.23-.07l-.2.12-.62.32-2.39,1.17-8.82,4.22-13.11,6.2-3.79,1.79-2,.92a4,4,0,0,1-2.26.49,3.77,3.77,0,0,1-1.26-7.17l29.25-13.62,1.37-.63a8.1,8.1,0,0,1,1.36-.56,3.67,3.67,0,0,1,2.65.33A3.61,3.61,0,0,1,410.6,200a3.55,3.55,0,0,1-1.29,2.32A2.78,2.78,0,0,1,408.5,202.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.89,231.73,318.58,246.4a3.51,3.51,0,0,1-4.68-1.69h0a3.51,3.51,0,0,1,1.69-4.68l31.32-14.67a3.52,3.52,0,0,1,4.68,1.69h0A3.52,3.52,0,0,1,349.89,231.73Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.89,231.73a6.42,6.42,0,0,0,.75-.54,3.44,3.44,0,0,0,1.15-2.26,3.38,3.38,0,0,0-1.81-3.36,3.43,3.43,0,0,0-2.44-.27,8.27,8.27,0,0,0-1.29.56l-1.36.65L315.7,240.26a3.27,3.27,0,0,0,1.09,6.21,3.56,3.56,0,0,0,2-.44l2-.92,3.8-1.77,13.16-6.1,8.89-4.08,2.43-1.08.64-.27.22-.08s-.06.05-.2.13l-.62.31-2.38,1.18-8.82,4.22-13.12,6.2L321,245.56l-2,.92a4,4,0,0,1-2.25.49,3.76,3.76,0,0,1-3.37-3,3.81,3.81,0,0,1,2.1-4.15l29.26-13.61,1.37-.64a8.88,8.88,0,0,1,1.35-.55,3.64,3.64,0,0,1,4.53,4,3.48,3.48,0,0,1-1.29,2.31A2.5,2.5,0,0,1,349.89,231.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.36,294.1a13.53,13.53,0,0,0-18.15-6l-18.34,9.24a13.51,13.51,0,0,0-6,18.15h0a13.51,13.51,0,0,0,18.15,6l18.34-9.24A13.53,13.53,0,0,0,209.36,294.1Zm-8.75,12.48-18.2,9.17a7.2,7.2,0,1,1-6.48-12.87l18.2-9.17a7.2,7.2,0,0,1,6.48,12.87Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.83,294.49l6-2.79a13.55,13.55,0,0,0-1.48-1.56l-6.14,3.37S201.67,294,201.83,294.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.36,302l6.34-.11a27,27,0,0,0,0-3.75L204.52,301Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.36,294.1a13.53,13.53,0,0,0-18.15-6l-18.34,9.24a13.51,13.51,0,0,0-6,18.15h0a13.51,13.51,0,0,0,18.15,6l18.34-9.24A13.53,13.53,0,0,0,209.36,294.1Zm-8.75,12.48-18.2,9.17a7.2,7.2,0,1,1-6.48-12.87l18.2-9.17a7.2,7.2,0,0,1,6.48,12.87Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.61,306.58a8.91,8.91,0,0,0,2.48-2.23,7.19,7.19,0,0,0,1.31-3.61,7,7,0,0,0-10.06-6.88L191,295.55c-4.59,2.33-9.64,4.88-14.94,7.55a7,7,0,0,0-3.79,6.9,7.16,7.16,0,0,0,1.47,3.64,7,7,0,0,0,3.06,2.21,7.1,7.1,0,0,0,3.58.34,11.51,11.51,0,0,0,3.22-1.27l5.7-2.84,8.27-4.07,2.26-1.09a4.8,4.8,0,0,1,.8-.34,7.18,7.18,0,0,1-.76.44l-2.21,1.17-8.2,4.22-5.67,2.89a11.55,11.55,0,0,1-3.34,1.33,7.38,7.38,0,0,1-3.82-.34,7.49,7.49,0,0,1-3.28-2.34,7.62,7.62,0,0,1-1.58-3.9,7.46,7.46,0,0,1,4.06-7.4l15-7.52,3.37-1.68a7.55,7.55,0,0,1,3.54-.72,7.41,7.41,0,0,1,5.59,3,7.22,7.22,0,0,1,1.41,5.05,7.15,7.15,0,0,1-3.29,5.42c-.24.15-.44.24-.57.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.36,294.1s.06.1.15.29.24.5.41.86.32.89.51,1.48a14.24,14.24,0,0,1,.39,2.09,13.59,13.59,0,0,1-.62,5.78,14.41,14.41,0,0,1-1.61,3.28,14.74,14.74,0,0,1-2.77,3,22.39,22.39,0,0,1-3.88,2.29l-4.32,2.19-9.54,4.84a36.17,36.17,0,0,1-5.3,2.41,13.52,13.52,0,0,1-6.08.36,13.78,13.78,0,0,1-5.83-2.43,13.66,13.66,0,0,1-5.68-11.27,13.66,13.66,0,0,1,1.52-6.13,13.34,13.34,0,0,1,3.9-4.67,35.33,35.33,0,0,1,5.09-2.83l9.57-4.79,4.34-2.17a21.39,21.39,0,0,1,4.14-1.75,14.55,14.55,0,0,1,4.08-.43,14.76,14.76,0,0,1,3.6.65,13.83,13.83,0,0,1,5,2.95,14.28,14.28,0,0,1,1.45,1.56c.36.5.66.93.88,1.28l.45.85c.1.19.14.29.14.29a15.75,15.75,0,0,0-3.06-3.83,13.46,13.46,0,0,0-5-2.82,13.47,13.47,0,0,0-7.49-.15,22.5,22.5,0,0,0-4.07,1.75l-4.32,2.2-9.54,4.83a35.73,35.73,0,0,0-5,2.8,12.79,12.79,0,0,0-3.75,4.51,13.1,13.1,0,0,0-1.46,5.9,13.19,13.19,0,0,0,5.47,10.86,13.14,13.14,0,0,0,5.61,2.34,13,13,0,0,0,5.86-.33,35.6,35.6,0,0,0,5.22-2.36l9.57-4.8,4.33-2.16a21.76,21.76,0,0,0,3.83-2.23,14.1,14.1,0,0,0,2.73-2.92,14.42,14.42,0,0,0,1.61-3.18,13.55,13.55,0,0,0,.69-5.67A15.51,15.51,0,0,0,209.36,294.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268,265.14a13.5,13.5,0,0,0-18.14-6l-18.34,9.24a13.5,13.5,0,0,0-6,18.14h0a13.5,13.5,0,0,0,18.14,6L262,283.28A13.51,13.51,0,0,0,268,265.14Zm-8.74,12.47L241,286.78a7.21,7.21,0,1,1-6.49-12.87l18.2-9.17a7.21,7.21,0,0,1,6.49,12.87Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.44,265.52l6-2.79a13.06,13.06,0,0,0-1.47-1.56l-6.14,3.38S260.28,265.07,260.44,265.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263,273l6.34-.12a25.88,25.88,0,0,0-.06-3.75L263.13,272Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268,265.14a13.5,13.5,0,0,0-18.14-6l-18.34,9.24a13.5,13.5,0,0,0-6,18.14h0a13.5,13.5,0,0,0,18.14,6L262,283.28A13.51,13.51,0,0,0,268,265.14Zm-8.74,12.47L241,286.78a7.21,7.21,0,1,1-6.49-12.87l18.2-9.17a7.21,7.21,0,0,1,6.49,12.87Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.22,277.61a8.59,8.59,0,0,0,2.47-2.22,7.08,7.08,0,0,0,1.31-3.62,7,7,0,0,0-6.73-7.58,7.16,7.16,0,0,0-3.33.7l-3.35,1.7-14.94,7.55a7,7,0,0,0-3.79,6.89,7,7,0,0,0,8.1,6.19,11.57,11.57,0,0,0,3.23-1.27l5.7-2.84,8.26-4.07,2.26-1.08a4.35,4.35,0,0,1,.81-.35,5.83,5.83,0,0,1-.76.44l-2.22,1.17-8.19,4.22-5.67,2.89a11.68,11.68,0,0,1-3.34,1.34,7.43,7.43,0,0,1-8.68-6.59,7.46,7.46,0,0,1,4.06-7.4l15-7.51,3.37-1.68a7.27,7.27,0,0,1,3.54-.72,7.35,7.35,0,0,1,5.58,3,7.25,7.25,0,0,1,1.42,5.05,7.17,7.17,0,0,1-1.44,3.71,6.85,6.85,0,0,1-1.85,1.71,5.11,5.11,0,0,1-.58.31C259.29,277.59,259.22,277.62,259.22,277.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268,265.14s.06.09.16.28l.41.87q.23.58.51,1.47a14.24,14.24,0,0,1,.39,2.09,13.58,13.58,0,0,1-.62,5.78,13.53,13.53,0,0,1-4.39,6.3,21.93,21.93,0,0,1-3.87,2.29l-4.33,2.2-9.54,4.83a34.7,34.7,0,0,1-5.3,2.41,13.38,13.38,0,0,1-6.08.36,13.57,13.57,0,0,1-5.82-2.43,14.12,14.12,0,0,1-4.22-4.94,13.92,13.92,0,0,1-1.46-6.33,13.68,13.68,0,0,1,1.51-6.13,13.47,13.47,0,0,1,3.91-4.67,35.76,35.76,0,0,1,5.09-2.83l9.57-4.79,4.33-2.17a22.39,22.39,0,0,1,4.15-1.75,14.93,14.93,0,0,1,4.08-.43,14.67,14.67,0,0,1,3.59.66,13.6,13.6,0,0,1,5,2.94,13.35,13.35,0,0,1,1.45,1.56c.36.5.66.93.88,1.29l.46.84a1.38,1.38,0,0,1,.13.3,14.91,14.91,0,0,0-3-3.84,13.68,13.68,0,0,0-5-2.82,14.38,14.38,0,0,0-3.53-.6,14.22,14.22,0,0,0-4,.46,21.09,21.09,0,0,0-4.06,1.75l-4.32,2.19-9.55,4.84a34.58,34.58,0,0,0-5,2.79,13.27,13.27,0,0,0-5.21,10.41,13.19,13.19,0,0,0,5.47,10.86,13.14,13.14,0,0,0,5.61,2.34,12.85,12.85,0,0,0,5.86-.33,35.6,35.6,0,0,0,5.22-2.36L256,286l4.34-2.17a22.1,22.1,0,0,0,3.83-2.22,14.93,14.93,0,0,0,2.73-2.92,14.49,14.49,0,0,0,1.61-3.19,13.53,13.53,0,0,0,.69-5.67A15.51,15.51,0,0,0,268,265.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.54,258.27l-31.32,14.66a3.51,3.51,0,0,1-4.68-1.69h0a3.52,3.52,0,0,1,1.7-4.68l31.31-14.67a3.52,3.52,0,0,1,4.68,1.7h0A3.51,3.51,0,0,1,292.54,258.27Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.54,258.27s.29-.15.74-.55a3.43,3.43,0,0,0-.65-5.62,3.38,3.38,0,0,0-2.44-.26,8.18,8.18,0,0,0-1.29.55l-1.37.65-29.18,13.75a3.27,3.27,0,0,0,1.09,6.21,3.51,3.51,0,0,0,2-.44l2-.92,3.8-1.77,13.16-6.1,8.89-4.07,2.43-1.09.63-.27c.15-.06.22-.08.23-.07l-.21.12-.61.32-2.39,1.17-8.82,4.22-13.11,6.2-3.8,1.79-2,.92a4,4,0,0,1-2.25.49,3.87,3.87,0,0,1-2.17-.94,3.78,3.78,0,0,1,.91-6.24l29.25-13.61,1.37-.64a9.32,9.32,0,0,1,1.35-.55,3.65,3.65,0,0,1,4.54,4,3.52,3.52,0,0,1-1.29,2.31A2.7,2.7,0,0,1,292.54,258.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.93,287.23,202.62,301.9a3.52,3.52,0,0,1-4.68-1.7h0a3.51,3.51,0,0,1,1.69-4.68L231,280.86a3.51,3.51,0,0,1,4.68,1.69h0A3.52,3.52,0,0,1,233.93,287.23Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.93,287.23a7.75,7.75,0,0,0,.74-.54,3.43,3.43,0,0,0,1.16-2.26,3.4,3.4,0,0,0-4.25-3.63,9.23,9.23,0,0,0-1.29.55l-1.36.65-29.19,13.76a3.26,3.26,0,0,0,1.09,6.2,3.48,3.48,0,0,0,2-.44l2-.91,3.8-1.77,13.16-6.1,8.89-4.08,2.43-1.08.64-.27.22-.08a.82.82,0,0,1-.2.13l-.62.31-2.38,1.17-8.83,4.23-13.11,6.2L205,301.05l-2,.92a4,4,0,0,1-2.26.49,3.79,3.79,0,0,1-2.17-.93,3.9,3.9,0,0,1-1.19-2.1,3.79,3.79,0,0,1,2.1-4.14l29.25-13.62,1.38-.63a8.88,8.88,0,0,1,1.35-.55,3.7,3.7,0,0,1,2.66.32,3.63,3.63,0,0,1,1.87,3.64,3.48,3.48,0,0,1-1.29,2.32A2.5,2.5,0,0,1,233.93,287.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.48,314.73l-31.31,14.66a3.51,3.51,0,0,1-4.68-1.69h0a3.51,3.51,0,0,1,1.69-4.68l31.32-14.67a3.53,3.53,0,0,1,4.68,1.7h0A3.53,3.53,0,0,1,175.48,314.73Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.48,314.73s.29-.15.75-.54a3.5,3.5,0,0,0,1.16-2.26,3.41,3.41,0,0,0-1.82-3.37,3.36,3.36,0,0,0-2.43-.26,7.8,7.8,0,0,0-1.29.55l-1.37.65-29.19,13.75a3.27,3.27,0,0,0,1.09,6.21,3.54,3.54,0,0,0,2-.44l2-.91,3.8-1.77,13.16-6.11,8.89-4.07,2.43-1.09.64-.27.22-.07s-.06,0-.2.12l-.61.32-2.39,1.17-8.82,4.22-13.12,6.2-3.79,1.79-2,.92a4,4,0,0,1-2.25.49,3.77,3.77,0,0,1-1.26-7.17l29.25-13.62,1.37-.63a8,8,0,0,1,1.35-.56,3.7,3.7,0,0,1,2.66.33,3.61,3.61,0,0,1,1.87,3.64,3.45,3.45,0,0,1-1.29,2.32A2.5,2.5,0,0,1,175.48,314.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.94,273.23a13.34,13.34,0,0,0-18.58-3.13l-25.43,18.08-3.32-4.67L261,265.42a19.09,19.09,0,0,1,26.57,4.49",
    style: {
      fill: "#0072BC"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M282.94,273.23a13.34,13.34,0,0,0-18.58-3.13l-25.43,18.08-3.32-4.67L261,265.42a19.09,19.09,0,0,1,26.57,4.49"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 228.06,
    y: 274.86,
    width: 32.95,
    height: 51.36,
    rx: 5.73,
    transform: "translate(-128.91 197.3) rotate(-35.41)",
    style: {
      fill: "#0072BC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.67,326.35a10.53,10.53,0,0,0,1.14,1.12,5.74,5.74,0,0,0,4.29,1.13,6.31,6.31,0,0,0,1.5-.43,8.55,8.55,0,0,0,1.46-.91l3.23-2.32,7.88-5.65,4.58-3.28a12.2,12.2,0,0,0,2.29-1.85,5.45,5.45,0,0,0,1.25-2.68,5.58,5.58,0,0,0-.36-3,18.76,18.76,0,0,0-1.78-2.74c-1.31-1.83-2.66-3.71-4-5.64L246.2,274.89a5.58,5.58,0,0,0-3.17-2.15,5.43,5.43,0,0,0-3.74.42,13.61,13.61,0,0,0-1.64,1.08L236,275.38l-3.19,2.27-12.13,8.63a5.51,5.51,0,0,0-1.71,6,11.75,11.75,0,0,0,1.69,2.78l1.86,2.63c2.44,3.44,4.71,6.66,6.78,9.59l9.79,13.91,2.65,3.8.67,1a1.86,1.86,0,0,1,.22.35,2.77,2.77,0,0,1-.26-.32l-.72-1L239,321.32l-9.92-13.82-6.84-9.56-1.87-2.62c-.32-.44-.63-.89-1-1.34a6.06,6.06,0,0,1-.79-1.54,6,6,0,0,1,1.83-6.53c3.87-2.81,7.93-5.66,12.14-8.67l3.19-2.27,1.61-1.15a13.11,13.11,0,0,1,1.7-1.11,6,6,0,0,1,4.09-.47,6,6,0,0,1,3.46,2.35C253,283.52,259,292,264.5,299.78l4,5.66,1,1.37a7.37,7.37,0,0,1,.86,1.46,6,6,0,0,1-1,6.16,12.33,12.33,0,0,1-2.38,1.9l-4.6,3.25-7.92,5.59-3.25,2.29a9.26,9.26,0,0,1-1.52.91,6.29,6.29,0,0,1-1.56.43,5.83,5.83,0,0,1-4.39-1.25A4.73,4.73,0,0,1,242.67,326.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M250.52,301.55a4.29,4.29,0,1,0-6.51-2.07l-5.24,3.72,1.36,1.91,5.23-3.72A4.27,4.27,0,0,0,250.52,301.55Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M220.36,289.58c-.07-.1,4.36-3.36,9.88-7.29s10.06-7,10.13-6.93-4.36,3.35-9.88,7.28S220.43,289.68,220.36,289.58Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.6,298.5a1.46,1.46,0,0,1-.06-.57,5.14,5.14,0,0,1,.28-1.56,6,6,0,0,1,8.6-3.49,5.37,5.37,0,0,1,1.28.92c.26.27.38.44.36.46a12.72,12.72,0,0,0-1.78-1.11,6,6,0,0,0-8.18,3.32A13,13,0,0,0,241.6,298.5Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308,413.15l6.4,18.73a13.26,13.26,0,0,0,16.82,8.25h0a13.25,13.25,0,0,0,8.25-16.83L333,404.25a13.25,13.25,0,0,0-18.22-7.68A13.46,13.46,0,0,0,308,413.15Zm11.12-11.65a7.22,7.22,0,0,1,8,4.88l6.31,18.44a7.25,7.25,0,0,1-3.5,8.89,7.08,7.08,0,0,1-9.79-4.06l-6.46-18.91A7.07,7.07,0,0,1,319.15,401.5Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.17,401.43l-2.27-6.05a12.63,12.63,0,0,1,2.1-.08l2,6.57S321.59,401.22,321.17,401.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.24,405l-4.36-4.43a27.35,27.35,0,0,1,2.61-2.59l2.33,6.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308,413.15l6.4,18.73a13.26,13.26,0,0,0,16.82,8.25h0a13.25,13.25,0,0,0,8.25-16.83L333,404.25a13.25,13.25,0,0,0-18.22-7.68A13.46,13.46,0,0,0,308,413.15Zm11.12-11.65a7.22,7.22,0,0,1,8,4.88l6.31,18.44a7.25,7.25,0,0,1-3.5,8.89,7.08,7.08,0,0,1-9.79-4.06l-6.46-18.91A7.07,7.07,0,0,1,319.15,401.5Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.15,401.5a9,9,0,0,0-2.94,1.41,6.93,6.93,0,0,0-2.23,3,7,7,0,0,0,0,4.92c1.26,3.61,2.74,7.89,4.39,12.65l1.26,3.66a23.64,23.64,0,0,0,1.44,3.7,6.85,6.85,0,0,0,7,3.18,6.6,6.6,0,0,0,3.61-1.89,6.88,6.88,0,0,0,1.83-3.53c.59-2.66-.85-5.12-1.54-7.52-1.61-4.76-3.06-9.06-4.28-12.69-.31-.89-.57-1.78-.88-2.55a7.28,7.28,0,0,0-1.27-2,7.13,7.13,0,0,0-3.15-2.08,6.48,6.48,0,0,0-2.38-.34,7.8,7.8,0,0,1-.86,0,.53.53,0,0,1,.21-.05,4.58,4.58,0,0,1,.64-.1,6.27,6.27,0,0,1,2.45.26,7.14,7.14,0,0,1,3.3,2.08,7.31,7.31,0,0,1,1.36,2.06c.34.81.6,1.66.92,2.57,1.26,3.61,2.74,7.9,4.39,12.65l1.26,3.66a8,8,0,0,1,.32,4.1,7.39,7.39,0,0,1-1.95,3.8,7.07,7.07,0,0,1-3.89,2,7.33,7.33,0,0,1-7.53-3.42,9.37,9.37,0,0,1-.83-1.91c-.22-.64-.43-1.27-.65-1.9-.42-1.24-.83-2.47-1.24-3.66-1.61-4.77-3.06-9.06-4.28-12.69a7.18,7.18,0,0,1,2.46-8.23,7.37,7.37,0,0,1,2.22-1.09c.27-.07.48-.1.63-.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308,413.15a1.17,1.17,0,0,1-.12-.3l-.28-.89a14,14,0,0,1-.44-3.58,13.48,13.48,0,0,1,1.24-5.56,12.59,12.59,0,0,1,1.9-3,12.45,12.45,0,0,1,3-2.65,14.64,14.64,0,0,1,4.08-1.71,13.89,13.89,0,0,1,4.79-.22,13.45,13.45,0,0,1,9,5.2l.8,1.18.67,1.26c.18.45.36.9.55,1.35s.31.9.46,1.36l1.92,5.59q2,5.72,4,11.77a13.48,13.48,0,0,1-24.27,11.48,22.16,22.16,0,0,1-1.67-4.09c-1.76-5.27-3.19-9.54-4.2-12.54-.47-1.46-.85-2.6-1.11-3.41l-.28-.9a1.31,1.31,0,0,1-.08-.31,1.79,1.79,0,0,1,.13.3l.32.87c.29.81.7,1.94,1.21,3.39l4.36,12.49a22,22,0,0,0,1.66,4,13,13,0,0,0,23.45-11.11l-4-11.77q-1-2.85-1.91-5.6l-.46-1.36c-.18-.44-.35-.87-.52-1.3s-.44-.82-.65-1.23l-.76-1.13a13.05,13.05,0,0,0-8.67-5.07,13.29,13.29,0,0,0-4.64.19,14,14,0,0,0-4,1.63,12,12,0,0,0-3,2.55,12.2,12.2,0,0,0-1.89,2.94,13.58,13.58,0,0,0-1.3,5.45A16.28,16.28,0,0,0,308,413.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.1,433.81l11.19,32a3.45,3.45,0,0,0,4.39,2.12h0a3.45,3.45,0,0,0,2.12-4.39l-11.19-32a3.45,3.45,0,0,0-4.4-2.12h0A3.46,3.46,0,0,0,325.1,433.81Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.1,433.81a2.36,2.36,0,0,1-.24-.88,3.47,3.47,0,0,1,.74-2.5,3.57,3.57,0,0,1,5.89.46,7.27,7.27,0,0,1,.54,1.33c.17.45.33.92.5,1.39,2.7,7.68,6.42,18.21,10.51,29.84a3.7,3.7,0,0,1-5.9,4,3.92,3.92,0,0,1-1.2-1.92c-.24-.67-.47-1.34-.7-2l-1.35-3.89c-1.74-5.05-3.31-9.6-4.64-13.44s-2.34-6.89-3.09-9.08l-.81-2.48-.2-.64a.82.82,0,0,1,0-.23.93.93,0,0,1,.1.21l.25.63.9,2.45c.78,2.17,1.89,5.24,3.24,9s3,8.37,4.75,13.41c.44,1.26.9,2.55,1.37,3.87l.7,2a3.48,3.48,0,0,0,1.06,1.7,3.2,3.2,0,0,0,5.09-3.49l-10.37-29.89c-.17-.48-.33-.94-.48-1.4a9,9,0,0,0-.5-1.28,3.32,3.32,0,0,0-5.45-.49,3.36,3.36,0,0,0-.79,2.36A8.43,8.43,0,0,0,325.1,433.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.66,232.33l6.51,19A13.25,13.25,0,0,0,267,259.63h0a13.26,13.26,0,0,0,8.25-16.82l-6.52-19.05a13.25,13.25,0,0,0-25.07,8.57Zm10.22-11.05a7.05,7.05,0,0,1,9,4.4l6.47,18.9A7.06,7.06,0,1,1,256,249.15l-6.47-18.9A7.07,7.07,0,0,1,253.88,221.28Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.91,220.94l-2.26-6.05a12.47,12.47,0,0,1,2.09-.08l2,6.57S257.34,220.73,256.91,220.94Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250,224.47,245.62,220a25.48,25.48,0,0,1,2.62-2.59l2.32,6.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.66,232.33l6.51,19A13.25,13.25,0,0,0,267,259.63h0a13.26,13.26,0,0,0,8.25-16.82l-6.52-19.05a13.25,13.25,0,0,0-25.07,8.57Zm10.22-11.05a7.05,7.05,0,0,1,9,4.4l6.47,18.9A7.06,7.06,0,1,1,256,249.15l-6.47-18.9A7.07,7.07,0,0,1,253.88,221.28Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.88,221.28a8.43,8.43,0,0,0-2.7,1.83,7,7,0,0,0-1.76,3.33,6.6,6.6,0,0,0-.1,2.36,12.52,12.52,0,0,0,.74,2.58c1.25,3.62,2.74,7.91,4.39,12.66l1.26,3.67c.22.61.42,1.27.67,1.86a6.72,6.72,0,0,0,1,1.67,6.81,6.81,0,0,0,12-4.11,6.38,6.38,0,0,0-.2-1.95c-.16-.62-.41-1.26-.61-1.89-.43-1.25-.84-2.47-1.25-3.67l-4.28-12.7a13.89,13.89,0,0,0-1-2.49,7.17,7.17,0,0,0-1.53-1.8,6.91,6.91,0,0,0-3.44-1.56,8.26,8.26,0,0,0-3.25.21l.2-.09a6.24,6.24,0,0,1,.62-.19,6.92,6.92,0,0,1,2.46-.13,7.09,7.09,0,0,1,3.59,1.54,7.19,7.19,0,0,1,1.63,1.85,14.19,14.19,0,0,1,1.05,2.55c1.25,3.62,2.74,7.9,4.39,12.66l1.26,3.66c.21.64.45,1.24.63,1.92a7.3,7.3,0,0,1-9.11,8.85,7.32,7.32,0,0,1-3.57-2.34,7.42,7.42,0,0,1-1.11-1.79c-.27-.66-.45-1.28-.67-1.91L254,244.2l-4.28-12.7a12.72,12.72,0,0,1-.73-2.66,7.19,7.19,0,0,1,2-5.87,6.85,6.85,0,0,1,2-1.41,5.18,5.18,0,0,1,.6-.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.66,232.33a1.2,1.2,0,0,1-.11-.3c-.08-.23-.17-.52-.29-.89a12.81,12.81,0,0,1-.39-3.59,13.23,13.23,0,0,1,1.37-5.53,14.14,14.14,0,0,1,2-3,14.35,14.35,0,0,1,3.1-2.56,13.45,13.45,0,0,1,17.79,3.68,13.93,13.93,0,0,1,1.4,2.47c.38.9.68,1.8,1,2.72q.93,2.74,1.92,5.59,1.95,5.72,4,11.77a13.89,13.89,0,0,1,.57,6.35A13.47,13.47,0,0,1,254,257.33a13.3,13.3,0,0,1-3-3.73,22.94,22.94,0,0,1-1.62-4.1c-1.77-5.27-3.2-9.55-4.21-12.55-.47-1.46-.85-2.6-1.11-3.42l-.28-.89a1.46,1.46,0,0,1-.08-.31,1.88,1.88,0,0,1,.13.29l.32.88c.29.81.7,1.94,1.21,3.39l4.36,12.49a24.42,24.42,0,0,0,1.62,4,13,13,0,0,0,22.05,1.12,12.89,12.89,0,0,0,2.2-5.53,13.12,13.12,0,0,0-.55-6.11c-1.38-4-2.72-8-4-11.77-.65-1.91-1.28-3.77-1.91-5.6-.31-.92-.61-1.83-1-2.68a13.72,13.72,0,0,0-1.35-2.4,13.09,13.09,0,0,0-8.54-5.27,13.23,13.23,0,0,0-8.68,1.63,13.11,13.11,0,0,0-5,5.35,13.23,13.23,0,0,0-1.43,5.41A15.3,15.3,0,0,0,243.66,232.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.46,171.84l6.51,19a13.24,13.24,0,0,0,16.82,8.25h0A13.24,13.24,0,0,0,254,182.32l-6.51-19a13.25,13.25,0,0,0-25.07,8.57Zm10.22-11.05a7.05,7.05,0,0,1,9,4.4l6.46,18.9a7.06,7.06,0,1,1-13.36,4.57l-6.47-18.9A7.07,7.07,0,0,1,232.68,160.79Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.71,160.45l-2.27-6a12.63,12.63,0,0,1,2.1-.08l2,6.57S236.13,160.24,235.71,160.45Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.79,164l-4.37-4.43A26.2,26.2,0,0,1,227,157l2.33,6.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.46,171.84l6.51,19a13.24,13.24,0,0,0,16.82,8.25h0A13.24,13.24,0,0,0,254,182.32l-6.51-19a13.25,13.25,0,0,0-25.07,8.57Zm10.22-11.05a7.05,7.05,0,0,1,9,4.4l6.46,18.9a7.06,7.06,0,1,1-13.36,4.57l-6.47-18.9A7.07,7.07,0,0,1,232.68,160.79Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.68,160.79a8.43,8.43,0,0,0-2.7,1.83,7,7,0,0,0-1.87,5.69,13.23,13.23,0,0,0,.75,2.58c1.25,3.62,2.74,7.91,4.39,12.66l1.26,3.67c.22.61.42,1.27.67,1.86a6.72,6.72,0,0,0,1,1.67,6.81,6.81,0,0,0,12-4.11,6.7,6.7,0,0,0-.2-1.95c-.16-.62-.41-1.26-.62-1.89-.42-1.25-.84-2.47-1.24-3.67-1.61-4.77-3.06-9.07-4.29-12.7a12.55,12.55,0,0,0-1-2.49,7,7,0,0,0-5-3.36,8.26,8.26,0,0,0-3.25.21s.06,0,.2-.09.34-.13.61-.19a7,7,0,0,1,2.47-.13,7.09,7.09,0,0,1,3.59,1.54,7.19,7.19,0,0,1,1.63,1.85,14.19,14.19,0,0,1,1,2.55c1.25,3.62,2.74,7.9,4.39,12.66l1.26,3.67c.21.63.45,1.23.63,1.91a7.05,7.05,0,0,1,.22,2.1,7.26,7.26,0,0,1-1.39,4,7.31,7.31,0,0,1-11.52.38,7.7,7.7,0,0,1-1.1-1.79c-.27-.65-.45-1.28-.67-1.9-.43-1.25-.84-2.48-1.25-3.67-1.61-4.77-3.06-9.07-4.29-12.7a13.32,13.32,0,0,1-.72-2.66,7.22,7.22,0,0,1,2-5.87,7,7,0,0,1,2-1.41,5.18,5.18,0,0,1,.6-.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.46,171.84a1.44,1.44,0,0,1-.12-.3c-.07-.23-.16-.52-.28-.89a13.13,13.13,0,0,1-.4-3.59,13.41,13.41,0,0,1,1.38-5.53,14.14,14.14,0,0,1,2-3,14.35,14.35,0,0,1,3.1-2.56,13.45,13.45,0,0,1,17.79,3.68,14.58,14.58,0,0,1,1.4,2.47c.38.9.68,1.8,1,2.72l1.92,5.59q2,5.72,4,11.77a13.9,13.9,0,0,1,.57,6.35,13.46,13.46,0,0,1-25.11,4.53,23.65,23.65,0,0,1-1.61-4.1c-1.77-5.27-3.2-9.55-4.21-12.55-.47-1.46-.85-2.6-1.12-3.42l-.27-.89a1.46,1.46,0,0,1-.08-.31,1.88,1.88,0,0,1,.13.29l.32.88c.29.81.7,1.94,1.21,3.39l4.36,12.49a24.42,24.42,0,0,0,1.62,4,12.87,12.87,0,0,0,3,3.59,13,13,0,0,0,21.29-8,13.27,13.27,0,0,0-.55-6.11c-1.38-4-2.72-8-4-11.77-.65-1.91-1.29-3.77-1.91-5.6-.31-.92-.61-1.83-1-2.68a13.72,13.72,0,0,0-1.35-2.4,13.07,13.07,0,0,0-17.22-3.64,14.44,14.44,0,0,0-3,2.47,14.81,14.81,0,0,0-2,2.88,13.4,13.4,0,0,0-1.43,5.41A15.37,15.37,0,0,0,222.46,171.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.57,117.82l6.51,19.06a13.26,13.26,0,0,0,16.83,8.25h0a13.25,13.25,0,0,0,8.24-16.83l-6.51-19.05a13.25,13.25,0,0,0-25.07,8.57Zm10.22-11a7.07,7.07,0,0,1,9,4.4l6.47,18.91a7.06,7.06,0,1,1-13.37,4.57l-6.47-18.91A7.07,7.07,0,0,1,213.79,106.77Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.82,106.43l-2.27-6.05a12.63,12.63,0,0,1,2.1-.08l2,6.58S217.25,106.22,216.82,106.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.9,110l-4.37-4.42a27.16,27.16,0,0,1,2.61-2.6l2.33,6.22Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.57,117.82l6.51,19.06a13.26,13.26,0,0,0,16.83,8.25h0a13.25,13.25,0,0,0,8.24-16.83l-6.51-19.05a13.25,13.25,0,0,0-25.07,8.57Zm10.22-11a7.07,7.07,0,0,1,9,4.4l6.47,18.91a7.06,7.06,0,1,1-13.37,4.57l-6.47-18.91A7.07,7.07,0,0,1,213.79,106.77Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.79,106.77a8.43,8.43,0,0,0-2.7,1.83,6.93,6.93,0,0,0-1.76,3.34,6.58,6.58,0,0,0-.1,2.36,12.61,12.61,0,0,0,.74,2.57c1.25,3.62,2.74,7.91,4.39,12.67l1.26,3.66c.22.62.42,1.28.67,1.86a6.72,6.72,0,0,0,1,1.67,6.81,6.81,0,0,0,12-4.11,6.7,6.7,0,0,0-.2-2c-.16-.62-.41-1.26-.61-1.88-.43-1.25-.84-2.48-1.25-3.67-1.61-4.77-3.06-9.07-4.29-12.7a13.29,13.29,0,0,0-1-2.5,7.35,7.35,0,0,0-1.53-1.8,7,7,0,0,0-3.44-1.56,8.77,8.77,0,0,0-3.25.21s.06,0,.2-.08a4.35,4.35,0,0,1,.62-.19,6.69,6.69,0,0,1,2.46-.13,7.07,7.07,0,0,1,3.59,1.53,7.24,7.24,0,0,1,1.63,1.86,13.8,13.8,0,0,1,1.05,2.54c1.25,3.62,2.74,7.91,4.39,12.67l1.26,3.66c.21.63.45,1.23.63,1.92a7.29,7.29,0,0,1,.23,2.09,7.3,7.3,0,0,1-9.34,6.75,7.31,7.31,0,0,1-4.68-4.13c-.27-.65-.45-1.27-.67-1.9-.43-1.25-.84-2.48-1.25-3.67L209.63,117a12.81,12.81,0,0,1-.73-2.65,7.15,7.15,0,0,1,.15-2.47,7.06,7.06,0,0,1,1.9-3.41,6.85,6.85,0,0,1,2-1.41,4.78,4.78,0,0,1,.6-.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.57,117.82s0-.09-.11-.29-.17-.53-.29-.9a12.78,12.78,0,0,1-.39-3.58,13.23,13.23,0,0,1,1.37-5.54,14.09,14.09,0,0,1,2-3,14.38,14.38,0,0,1,3.1-2.57,13.45,13.45,0,0,1,17.79,3.68,14,14,0,0,1,1.4,2.48c.38.89.68,1.8,1,2.71q.93,2.75,1.92,5.6l4,11.77a13.89,13.89,0,0,1,.57,6.35,13.47,13.47,0,0,1-25.11,4.53,24.05,24.05,0,0,1-1.61-4.11c-1.77-5.27-3.2-9.55-4.21-12.54-.47-1.46-.85-2.61-1.12-3.42l-.27-.9a1.31,1.31,0,0,1-.08-.31,1.79,1.79,0,0,1,.13.3l.32.87c.29.81.7,2,1.21,3.39l4.36,12.5a24.78,24.78,0,0,0,1.62,4,13,13,0,0,0,24.25-4.42,13.27,13.27,0,0,0-.55-6.11c-1.38-4-2.72-8-4-11.77q-1-2.85-1.91-5.6c-.31-.92-.61-1.83-1-2.68a13.63,13.63,0,0,0-1.35-2.39,13.07,13.07,0,0,0-8.54-5.28,13.29,13.29,0,0,0-8.68,1.63,13.11,13.11,0,0,0-5,5.35,13.08,13.08,0,0,0-1.43,5.41A15.14,15.14,0,0,0,203.57,117.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.31,79.34l11.88,31.75a3.46,3.46,0,0,0,4.45,2h0a3.45,3.45,0,0,0,2-4.44L205.77,76.92a3.45,3.45,0,0,0-4.44-2h0A3.46,3.46,0,0,0,199.31,79.34Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.31,79.34a2.46,2.46,0,0,1-.25-.88,3.41,3.41,0,0,1,.68-2.51,3.57,3.57,0,0,1,5.9.33,8,8,0,0,1,.57,1.31l.53,1.39,11.16,29.6a3.73,3.73,0,0,1-1.37,4.35,3.78,3.78,0,0,1-2.27.65,3.69,3.69,0,0,1-2.17-.84,3.89,3.89,0,0,1-1.25-1.89c-.25-.67-.5-1.33-.74-2-.49-1.31-1-2.59-1.43-3.85-1.86-5-3.53-9.53-4.94-13.34l-3.28-9c-.37-1-.66-1.85-.87-2.45l-.22-.65a.73.73,0,0,1-.05-.22s0,.06.1.2l.27.63.95,2.42,3.44,9,5,13.3c.47,1.26.95,2.54,1.45,3.85.25.66.49,1.32.75,2a3.4,3.4,0,0,0,1.09,1.67,3.2,3.2,0,0,0,5-3.59c-4.3-11.56-8.19-22-11-29.66-.18-.47-.35-.93-.51-1.39a9.32,9.32,0,0,0-.53-1.27,3.33,3.33,0,0,0-5.46-.37,3.4,3.4,0,0,0-.74,2.38C199.21,79,199.34,79.33,199.31,79.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.4,193.84l11.88,31.75a3.47,3.47,0,0,0,4.45,2h0a3.46,3.46,0,0,0,2-4.45l-11.89-31.75a3.45,3.45,0,0,0-4.44-2h0A3.45,3.45,0,0,0,239.4,193.84Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.4,193.84a2.46,2.46,0,0,1-.25-.88,3.43,3.43,0,0,1,.68-2.51,3.58,3.58,0,0,1,5.9.33,8.48,8.48,0,0,1,.57,1.32l.53,1.38L258,223.08a3.72,3.72,0,0,1-3.64,5,3.76,3.76,0,0,1-2.17-.84,3.94,3.94,0,0,1-1.25-1.89c-.25-.67-.5-1.33-.74-2-.49-1.31-1-2.6-1.43-3.85l-4.94-13.34-3.28-9-.87-2.46c-.09-.26-.16-.47-.21-.64a.7.7,0,0,1-.06-.23.93.93,0,0,1,.1.21c.08.17.16.37.27.62q.34.9,1,2.43c.82,2.16,2,5.2,3.43,9s3.15,8.3,5,13.3l1.45,3.85.75,2a3.47,3.47,0,0,0,1.09,1.67,3.2,3.2,0,0,0,5-3.6c-4.3-11.56-8.19-22-11-29.65l-.51-1.39a9.32,9.32,0,0,0-.53-1.27,3.28,3.28,0,0,0-1.89-1.49,3.34,3.34,0,0,0-3.57,1.12,3.37,3.37,0,0,0-.74,2.37C239.3,193.54,239.43,193.83,239.4,193.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287,351.07l6.4,18.73a13.26,13.26,0,0,0,16.82,8.25h0a13.25,13.25,0,0,0,8.25-16.83l-6.51-19.05a13.25,13.25,0,0,0-18.22-7.68A13.46,13.46,0,0,0,287,351.07Zm11.12-11.65a7.23,7.23,0,0,1,8,4.88l6.31,18.44a7.24,7.24,0,0,1-3.5,8.89,7.08,7.08,0,0,1-9.79-4.06l-6.46-18.91A7.07,7.07,0,0,1,298.09,339.42Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.11,339.35l-2.27-6.05a12.63,12.63,0,0,1,2.1-.08l2,6.57S300.53,339.14,300.11,339.35Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.19,342.88l-4.37-4.42a27.16,27.16,0,0,1,2.61-2.6l2.33,6.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287,351.07l6.4,18.73a13.26,13.26,0,0,0,16.82,8.25h0a13.25,13.25,0,0,0,8.25-16.83l-6.51-19.05a13.25,13.25,0,0,0-18.22-7.68A13.46,13.46,0,0,0,287,351.07Zm11.12-11.65a7.23,7.23,0,0,1,8,4.88l6.31,18.44a7.24,7.24,0,0,1-3.5,8.89,7.08,7.08,0,0,1-9.79-4.06l-6.46-18.91A7.07,7.07,0,0,1,298.09,339.42Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.09,339.42a8.88,8.88,0,0,0-2.93,1.41,7,7,0,0,0-2.24,3,7,7,0,0,0,0,4.92c1.26,3.61,2.74,7.9,4.39,12.65l1.26,3.66a23.64,23.64,0,0,0,1.44,3.7,6.85,6.85,0,0,0,7,3.18,6.54,6.54,0,0,0,3.61-1.89,6.88,6.88,0,0,0,1.83-3.53c.59-2.66-.85-5.12-1.54-7.52-1.61-4.76-3.06-9.06-4.28-12.69-.31-.89-.57-1.78-.88-2.55a7.28,7.28,0,0,0-1.27-2,7.16,7.16,0,0,0-3.14-2.08,6.53,6.53,0,0,0-2.39-.34,7.8,7.8,0,0,1-.86,0l.22-.05a4.16,4.16,0,0,1,.63-.1,6.27,6.27,0,0,1,2.45.26,7.14,7.14,0,0,1,3.3,2.08,7.31,7.31,0,0,1,1.36,2.06c.34.81.6,1.66.92,2.57,1.26,3.61,2.74,7.9,4.39,12.65l1.26,3.66a8,8,0,0,1,.33,4.1,7.49,7.49,0,0,1-2,3.8,7.07,7.07,0,0,1-3.89,2,7.33,7.33,0,0,1-7.53-3.42,9.37,9.37,0,0,1-.83-1.91c-.22-.64-.43-1.27-.65-1.89-.42-1.25-.83-2.48-1.24-3.67-1.61-4.76-3.06-9.06-4.28-12.69a7.22,7.22,0,0,1,.09-5.14,7.13,7.13,0,0,1,2.37-3.09,7.37,7.37,0,0,1,2.22-1.09c.27-.07.49-.1.63-.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287,351.07s-.05-.09-.12-.29-.16-.53-.28-.9a14.47,14.47,0,0,1-.44-3.58,13.64,13.64,0,0,1,1.24-5.56,12.59,12.59,0,0,1,1.9-3,12.45,12.45,0,0,1,3-2.65,14.64,14.64,0,0,1,4.08-1.71,13.89,13.89,0,0,1,4.79-.22,13.45,13.45,0,0,1,9,5.2l.8,1.18.67,1.26c.18.45.36.9.55,1.35s.31.9.46,1.36l1.92,5.6c1.31,3.8,2.65,7.73,4,11.76a13.48,13.48,0,0,1-24.27,11.48,21.42,21.42,0,0,1-1.66-4.09l-4.21-12.54c-.47-1.46-.85-2.6-1.11-3.41-.12-.37-.21-.67-.28-.9a1.31,1.31,0,0,1-.08-.31,1.79,1.79,0,0,1,.13.3l.32.87c.29.81.7,1.94,1.21,3.39L293,368.12a22,22,0,0,0,1.66,4A13,13,0,0,0,318.1,361c-1.38-4-2.72-8-4-11.77q-1-2.85-1.91-5.6c-.15-.46-.31-.91-.46-1.36s-.35-.87-.52-1.3-.44-.82-.65-1.23l-.76-1.13a13,13,0,0,0-8.67-5.07,13.54,13.54,0,0,0-4.64.19,14,14,0,0,0-4,1.63,12,12,0,0,0-3,2.55,12.51,12.51,0,0,0-1.89,2.94,13.58,13.58,0,0,0-1.3,5.45A16.28,16.28,0,0,0,287,351.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.83,370.14l11.19,32a3.46,3.46,0,0,0,4.4,2.11h0a3.44,3.44,0,0,0,2.12-4.39l-11.19-32a3.46,3.46,0,0,0-4.4-2.12h0A3.45,3.45,0,0,0,302.83,370.14Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.83,370.14a2.51,2.51,0,0,1-.23-.88,3.43,3.43,0,0,1,.74-2.5,3.57,3.57,0,0,1,5.89.46,8.06,8.06,0,0,1,.54,1.33l.5,1.39c2.7,7.68,6.41,18.21,10.51,29.84A3.71,3.71,0,0,1,317,404.7a3.75,3.75,0,0,1-2.15-.88,3.92,3.92,0,0,1-1.2-1.92c-.24-.67-.47-1.34-.7-2L311.63,396c-1.75-5.05-3.32-9.6-4.64-13.44s-2.35-6.89-3.09-9.08c-.34-1-.62-1.87-.82-2.47-.08-.26-.14-.48-.2-.65a.82.82,0,0,1-.05-.23.93.93,0,0,1,.1.21l.25.63.91,2.45,3.24,9c1.36,3.83,3,8.37,4.75,13.41.44,1.26.9,2.55,1.36,3.88.23.66.47,1.32.71,2a3.41,3.41,0,0,0,1.06,1.7A3.2,3.2,0,0,0,320.3,400c-4.05-11.65-7.71-22.2-10.38-29.89l-.48-1.4a8.32,8.32,0,0,0-.49-1.28,3.37,3.37,0,0,0-1.86-1.53,3.33,3.33,0,0,0-3.6,1,3.43,3.43,0,0,0-.79,2.36C302.74,369.84,302.86,370.13,302.83,370.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.65,290.25l6.52,19.06A13.26,13.26,0,0,0,289,317.56h0a13.25,13.25,0,0,0,8.25-16.83l-6.51-19.05a13.25,13.25,0,0,0-25.08,8.57Zm10.23-11.05a7.07,7.07,0,0,1,9,4.4l6.46,18.91a7.06,7.06,0,1,1-13.37,4.57l-6.46-18.91A7.06,7.06,0,0,1,275.88,279.2Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.91,278.86l-2.27-6.05a12.63,12.63,0,0,1,2.1-.08l2,6.58S279.33,278.65,278.91,278.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272,282.39,267.62,278a27.16,27.16,0,0,1,2.61-2.6l2.33,6.22Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.65,290.25l6.52,19.06A13.26,13.26,0,0,0,289,317.56h0a13.25,13.25,0,0,0,8.25-16.83l-6.51-19.05a13.25,13.25,0,0,0-25.08,8.57Zm10.23-11.05a7.07,7.07,0,0,1,9,4.4l6.46,18.91a7.06,7.06,0,1,1-13.37,4.57l-6.46-18.91A7.06,7.06,0,0,1,275.88,279.2Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.88,279.2a8.43,8.43,0,0,0-2.7,1.83,7.07,7.07,0,0,0-1.87,5.7,13.35,13.35,0,0,0,.75,2.57c1.25,3.62,2.74,7.91,4.39,12.67l1.26,3.66c.22.62.41,1.28.67,1.86a6.28,6.28,0,0,0,1,1.67,6.81,6.81,0,0,0,12-4.11,6.71,6.71,0,0,0-.21-1.95c-.15-.62-.41-1.26-.61-1.88l-1.24-3.67c-1.61-4.77-3.06-9.07-4.29-12.7a12.55,12.55,0,0,0-1-2.49,6.83,6.83,0,0,0-1.53-1.81,7.1,7.1,0,0,0-3.43-1.56,8.69,8.69,0,0,0-3.25.21s.06,0,.2-.08a4.58,4.58,0,0,1,.61-.19,6.75,6.75,0,0,1,2.47-.13,7.12,7.12,0,0,1,5.21,3.39,13.16,13.16,0,0,1,1.06,2.54c1.25,3.62,2.74,7.91,4.38,12.67.42,1.19.84,2.41,1.27,3.66.2.63.45,1.23.63,1.92a7.35,7.35,0,0,1-1.18,6.13,7.3,7.3,0,0,1-11.51.37,6.75,6.75,0,0,1-1.1-1.79c-.28-.65-.45-1.27-.68-1.9-.42-1.25-.84-2.47-1.24-3.67-1.61-4.77-3.06-9.07-4.29-12.7a13.42,13.42,0,0,1-.72-2.65,6.91,6.91,0,0,1,.15-2.47,7,7,0,0,1,3.92-4.82,6.31,6.31,0,0,1,.6-.22C275.8,279.21,275.87,279.19,275.88,279.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.65,290.25a2.54,2.54,0,0,1-.11-.29c-.07-.23-.16-.53-.28-.9a13.1,13.1,0,0,1-.4-3.58,13.34,13.34,0,0,1,1.38-5.53,14.21,14.21,0,0,1,2-3,14.45,14.45,0,0,1,3.11-2.57,13.44,13.44,0,0,1,17.78,3.68,14.06,14.06,0,0,1,1.41,2.48c.38.89.68,1.8,1,2.71l1.92,5.6,4,11.77a13.76,13.76,0,0,1,.58,6.35A13.47,13.47,0,0,1,273,311.53a24.12,24.12,0,0,1-1.62-4.11c-1.76-5.27-3.2-9.55-4.2-12.54-.48-1.46-.85-2.61-1.12-3.42l-.28-.9a2.52,2.52,0,0,1-.08-.31,1.13,1.13,0,0,1,.13.3c.09.22.19.51.33.87.29.81.69,1.95,1.21,3.39l4.36,12.5a23.1,23.1,0,0,0,1.62,4A13,13,0,0,0,285.82,318a13,13,0,0,0,11.73-11.05,13.41,13.41,0,0,0-.55-6.11c-1.38-4-2.72-8-4-11.77q-1-2.85-1.91-5.6c-.31-.92-.61-1.83-1-2.68a13.63,13.63,0,0,0-1.35-2.39,13,13,0,0,0-17.22-3.64,13.13,13.13,0,0,0-5,5.34,13.44,13.44,0,0,0-1.43,5.41A15.53,15.53,0,0,0,265.65,290.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.4,251.77l11.88,31.75a3.45,3.45,0,0,0,4.44,2h0a3.44,3.44,0,0,0,2-4.44l-11.88-31.75a3.46,3.46,0,0,0-4.44-2h0A3.45,3.45,0,0,0,261.4,251.77Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.4,251.77a2.57,2.57,0,0,1-.26-.88,3.47,3.47,0,0,1,.69-2.51,3.54,3.54,0,0,1,3.81-1.27,3.62,3.62,0,0,1,2.09,1.6,9,9,0,0,1,.57,1.31l.52,1.39L280,281a3.7,3.7,0,0,1-5.81,4.16,3.94,3.94,0,0,1-1.24-1.89c-.25-.67-.5-1.33-.74-2l-1.44-3.85-4.93-13.34c-1.38-3.77-2.49-6.84-3.29-9l-.86-2.45-.22-.65a.73.73,0,0,1-.05-.22.88.88,0,0,1,.1.2l.26.63c.24.59.56,1.4,1,2.42l3.44,9c1.44,3.8,3.14,8.31,5,13.3.47,1.26.95,2.54,1.45,3.85.24.66.49,1.32.74,2a3.48,3.48,0,0,0,1.1,1.67,3.19,3.19,0,0,0,5-3.59c-4.29-11.56-8.18-22-11-29.66l-.51-1.39a8.2,8.2,0,0,0-.52-1.27,3.35,3.35,0,0,0-6.2,2A5.92,5.92,0,0,0,261.4,251.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.6,312.26,294.48,344a3.45,3.45,0,0,0,4.44,2h0a3.46,3.46,0,0,0,2-4.44l-11.89-31.75a3.46,3.46,0,0,0-4.44-2h0A3.45,3.45,0,0,0,282.6,312.26Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.6,312.26a2.46,2.46,0,0,1-.25-.88,3.41,3.41,0,0,1,.68-2.51,3.54,3.54,0,0,1,3.81-1.27,3.59,3.59,0,0,1,2.09,1.6,9,9,0,0,1,.57,1.31l.53,1.39c2.87,7.61,6.8,18.06,11.16,29.6a3.7,3.7,0,0,1-5.82,4.16,3.94,3.94,0,0,1-1.24-1.89c-.25-.67-.5-1.33-.74-2L292,337.93,287,324.59l-3.28-9q-.56-1.54-.87-2.46c-.09-.25-.16-.46-.22-.64a.8.8,0,0,1,0-.22s0,.06.1.2l.26.63c.24.59.56,1.4,1,2.42l3.44,8.95,5,13.3c.47,1.26,1,2.54,1.45,3.85.24.66.49,1.32.74,2a3.48,3.48,0,0,0,1.1,1.67,3.19,3.19,0,0,0,5-3.59l-11-29.66c-.18-.47-.35-.94-.52-1.39a8.2,8.2,0,0,0-.52-1.27,3.33,3.33,0,0,0-5.46-.37,3.35,3.35,0,0,0-.74,2.38C282.5,312,282.63,312.25,282.6,312.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.2,133.35l11.88,31.75a3.46,3.46,0,0,0,4.44,2h0a3.46,3.46,0,0,0,2-4.44l-11.89-31.76a3.45,3.45,0,0,0-4.44-2h0A3.44,3.44,0,0,0,218.2,133.35Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.2,133.35a2.46,2.46,0,0,1-.25-.88,3.43,3.43,0,0,1,.68-2.51,3.58,3.58,0,0,1,5.9.33,9.56,9.56,0,0,1,.57,1.32l.53,1.38,11.16,29.6a3.72,3.72,0,0,1-3.65,5,3.76,3.76,0,0,1-2.16-.84,3.94,3.94,0,0,1-1.25-1.89c-.25-.67-.5-1.33-.74-2-.49-1.31-1-2.6-1.43-3.85-1.86-5-3.53-9.53-4.94-13.34l-3.28-9-.87-2.46-.22-.64a.76.76,0,0,1-.05-.23.93.93,0,0,1,.1.21c.07.17.16.37.26.63l1,2.42,3.44,8.95c1.44,3.8,3.15,8.3,5,13.3.47,1.25.95,2.54,1.45,3.85.24.65.49,1.32.75,2a3.4,3.4,0,0,0,1.09,1.67,3.2,3.2,0,0,0,5-3.6c-4.3-11.56-8.19-22-11-29.65-.18-.47-.35-.94-.52-1.39a8.2,8.2,0,0,0-.52-1.27,3.31,3.31,0,0,0-5.46-.37,3.37,3.37,0,0,0-.74,2.37C218.1,133.05,218.23,133.34,218.2,133.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.61,269.91l-4.67,3.32a13.34,13.34,0,0,1-3.14,18.58l-14.27,10.06,3.33,4.67,14.26-10.06A19.07,19.07,0,0,0,287.61,269.91Z",
    style: {
      fill: "#0072BC"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M287.61,269.91l-4.67,3.32a13.34,13.34,0,0,1-3.14,18.58l-14.27,10.06,3.33,4.67,14.26-10.06A19.07,19.07,0,0,0,287.61,269.91Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M241.82,251.89a7.76,7.76,0,0,1-1.1-.81l-2.89-2.35c-2.44-2-5.8-4.75-9.55-7.74s-7.19-5.67-9.67-7.6l-2.93-2.3a6.83,6.83,0,0,1-1-.9,7.48,7.48,0,0,1,1.16.74c.72.5,1.76,1.24,3,2.17,2.54,1.86,6,4.49,9.77,7.49s7.08,5.79,9.46,7.86c1.19,1,2.14,1.88,2.79,2.47A6.2,6.2,0,0,1,241.82,251.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.18,254.47a16.06,16.06,0,0,1-2.82,0l-6.79-.2-6.8-.06a15.3,15.3,0,0,1-2.82-.11,16.27,16.27,0,0,1,2.82-.26c1.74-.08,4.15-.13,6.81-.08s5.06.19,6.8.34A14,14,0,0,1,235.18,254.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.66,202.4c.14,0-.54,7.79-1.51,17.37s-1.89,17.34-2,17.33.54-7.8,1.51-17.38S285.52,202.39,285.66,202.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.36,217.4a74,74,0,0,1-5.81,6.42,72.35,72.35,0,0,1-6.17,6.07,73,73,0,0,1,5.8-6.42A71.53,71.53,0,0,1,301.36,217.4Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M484.93,462.57c0,.14-105.19.26-234.92.26s-234.94-.12-234.94-.26,105.17-.26,234.94-.26S484.93,462.42,484.93,462.57Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M365.15,176.72a13,13,0,0,1-.3-3.22,4.35,4.35,0,0,1,1.27-2.91c1-.91,2.45-1.09,3.66-1.69a11.46,11.46,0,0,0,3.69-3.58,17.45,17.45,0,0,1,.54,5.57,8,8,0,0,1-2.24,5,5.28,5.28,0,0,1-5.17,1.35",
    style: {
      fill: "#0072BC"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M365.15,176.72a13,13,0,0,1-.3-3.22,4.35,4.35,0,0,1,1.27-2.91c1-.91,2.45-1.09,3.66-1.69a11.46,11.46,0,0,0,3.69-3.58,17.45,17.45,0,0,1,.54,5.57,8,8,0,0,1-2.24,5,5.28,5.28,0,0,1-5.17,1.35"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M371.36,170.07a5.08,5.08,0,0,1-1,1.82,5.16,5.16,0,0,1-1.5,1.43s.65-.66,1.34-1.55S371.3,170.05,371.36,170.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.82,171.63a3.65,3.65,0,0,1-1.22,1,3.72,3.72,0,0,1-1.46.57,14.2,14.2,0,0,1,1.36-.74A12.54,12.54,0,0,1,371.82,171.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.47,176.64a4.23,4.23,0,0,1,3-3,20,20,0,0,1,4.38-.62,7.06,7.06,0,0,0,4.1-1.5,9.27,9.27,0,0,1-1.83,5.59,7.31,7.31,0,0,1-5.05,2.89,6.07,6.07,0,0,1-5.3-2.23",
    style: {
      fill: "#0072BC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.59,175.36a5.77,5.77,0,0,1-.95.32c-.6.18-1.41.44-2.3.75s-1.68.62-2.25.85a7.44,7.44,0,0,1-.94.35,3.49,3.49,0,0,1,.88-.48c.56-.27,1.35-.6,2.24-.92s1.72-.54,2.33-.69A3.75,3.75,0,0,1,371.59,175.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.23,177.06a5.53,5.53,0,0,1-1,.06c-.6,0-1.44.06-2.36.15s-1.75.22-2.35.33a5.56,5.56,0,0,1-1,.14,3.84,3.84,0,0,1,.95-.28,17.85,17.85,0,0,1,2.35-.39,19.42,19.42,0,0,1,2.38-.1A4,4,0,0,1,371.23,177.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.82,173.72,380.21,204a10.94,10.94,0,0,1-3.65,15h0a10.93,10.93,0,0,1-14.68-3.08c-1.82-2.6-3.32-4.78-3.32-4.78s-7.88,4-13.1-3c-2.52-3.38-7.14-10.76-11.25-17.5a16.37,16.37,0,0,1,5-22.21h0A16.18,16.18,0,0,1,361.82,173.72Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.57,211.15a20.34,20.34,0,0,0,7.32-9.33s1.52,6.68-6,11.17Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.29,194.28a1.27,1.27,0,0,0,1.72.31,1.19,1.19,0,0,0,.38-1.67,1.24,1.24,0,0,0-1.71-.31A1.2,1.2,0,0,0,339.29,194.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.31,193.08c.23,0,.58-1.08,1.67-1.87s2.28-.82,2.3-1-.28-.24-.81-.24a3.42,3.42,0,0,0-2,.66,3.3,3.3,0,0,0-1.2,1.66C338.15,192.75,338.21,193.07,338.31,193.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.19,187.05a1.25,1.25,0,0,0,1.71.31,1.19,1.19,0,0,0,.38-1.67,1.24,1.24,0,0,0-1.71-.31A1.19,1.19,0,0,0,350.19,187.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.16,185.52c.22,0,.58-1.08,1.66-1.87s2.29-.82,2.31-1-.29-.24-.82-.24a3.41,3.41,0,0,0-2,.66,3.26,3.26,0,0,0-1.21,1.66C349,185.19,349.05,185.51,349.16,185.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.07,196.46a8.62,8.62,0,0,0-2,1c-.3.17-.6.31-.79.15a1.72,1.72,0,0,1-.41-.95l-.72-2.72A43.65,43.65,0,0,0,345,187a45.61,45.61,0,0,0,1.62,7c.26.95.51,1.84.75,2.7A2.05,2.05,0,0,0,348,198a.87.87,0,0,0,.75.07,2.09,2.09,0,0,0,.52-.27A9.45,9.45,0,0,0,351.07,196.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.81,194.89c-.18.11.68,1.3.27,2.87s-1.75,2.35-1.64,2.53.45,0,1-.35a3.67,3.67,0,0,0,1.42-2,3.21,3.21,0,0,0-.3-2.36C355.23,195,354.89,194.82,354.81,194.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.49,182.12c.37.1,1-1.08,2.1-2.25s2.18-1.94,2-2.31c-.08-.16-.49-.19-1.07,0a5.36,5.36,0,0,0-3.16,3.47C346.25,181.66,346.31,182.06,346.49,182.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.16,189c.38.19,1.35-.5,2.64-1s2.45-.68,2.6-1.07c.05-.18-.22-.41-.8-.51a4.89,4.89,0,0,0-4.22,1.65C335,188.54,335,188.89,335.16,189Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.59,171.65h.06a6.91,6.91,0,0,1,4.69,2.1l.12.13c1.74,1.82,3.18,3.91,4.94,5.71a11.35,11.35,0,0,0,6.45,3.66c1,.12,2.4-.27,2.42-1.31a2.14,2.14,0,0,0-.42-1.11c-3.16-5.15-5-10.44-8.68-15.53a5.31,5.31,0,0,0-4.32-2.21c-1.63,0-3.51.16-4.29,1.59s-.7,4.76-.94,6.37",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.85,178.77c.08-.14,3.82-5,7.18,0s-2.31,7.31-2.41,7.17S361.85,178.77,361.85,178.77Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.86,183s.13,0,.32,0a1,1,0,0,0,.65-.42,2.57,2.57,0,0,0-.31-2.59,3.34,3.34,0,0,0-1.08-1.07,1.18,1.18,0,0,0-1.1-.22.53.53,0,0,0-.35.58c0,.18.13.26.11.28s-.16,0-.26-.24a.64.64,0,0,1,0-.44.79.79,0,0,1,.4-.45,1.47,1.47,0,0,1,1.42.16,3.59,3.59,0,0,1,1.23,1.17,2.7,2.7,0,0,1,.19,3,1.09,1.09,0,0,1-.87.4C367,183.13,366.85,183,366.86,183Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.09,170a1.09,1.09,0,0,1-.34.38,2.39,2.39,0,0,1-1.28.5,3.48,3.48,0,0,1-2-.45,9.44,9.44,0,0,1-2-1.52,10.05,10.05,0,0,0-1.93-1.48,3.26,3.26,0,0,0-1.88-.43,2.36,2.36,0,0,0-1.24.43,4.69,4.69,0,0,0-.37.32,1,1,0,0,1,.31-.4,2.39,2.39,0,0,1,1.28-.53,3.43,3.43,0,0,1,2,.4,9.83,9.83,0,0,1,2,1.51,10.24,10.24,0,0,0,1.92,1.5,3.33,3.33,0,0,0,1.87.47,2.45,2.45,0,0,0,1.25-.4C361,170.1,361.07,170,361.09,170Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362,171.65l-27.19,20,5,8S350,193.85,353.33,191s11.21-14.29,11.21-14.29ZM341.8,196.71a3.82,3.82,0,1,1,3.08-4.43A3.82,3.82,0,0,1,341.8,196.71Zm10.85-7.94a3.81,3.81,0,1,1,3.08-4.42A3.8,3.8,0,0,1,352.65,188.77Z",
    style: {
      fill: "#0072BC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.22,174.49c0,.93-.14,1.87-.68,2.19,0,0-3.08-4-7.92-3.33a39.82,39.82,0,0,0-14,5.56c-4,2.66-7.92,5.51-8.28,6.42s-.91,4.24-.44,5a8.91,8.91,0,0,1,.72,1.55,2.68,2.68,0,0,1-3-.09c-.76-.52-3.64-5.64-3.55-7.46.61-12,26.12-18.82,28.49-18.62,0,0,4-1.21,6.28,2.3.17.27,1,1.92,1.6,3.1A7.48,7.48,0,0,1,365.22,174.49Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.19,161.82s-8.58,3.76-10.12,11.56c-1.23,6.23,1.5,8.35,1.5,8.35L360,168S354.93,155.6,338.19,161.82Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.68,165.83h-1.39a29.53,29.53,0,0,0-3.77.28,27,27,0,0,0-5.44,1.36,56.3,56.3,0,0,0-6.29,2.78,39.58,39.58,0,0,0-10,7.41c-1.12,1.14-2,2.13-2.53,2.82l-.64.81c-.15.18-.24.27-.24.27a30.68,30.68,0,0,1,3.3-4,38.61,38.61,0,0,1,10-7.5,55.69,55.69,0,0,1,6.32-2.77A26.29,26.29,0,0,1,353.5,166a27.81,27.81,0,0,1,3.79-.22c.45,0,.8,0,1,0A3.28,3.28,0,0,1,358.68,165.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.77,190.42a1.86,1.86,0,0,1-.35-.22,8.68,8.68,0,0,1-.87-.72,12.29,12.29,0,0,1-2.33-2.89,12.69,12.69,0,0,1-1.37-3.46,8.88,8.88,0,0,1-.19-1.11,1.6,1.6,0,0,1,0-.41s.11.58.35,1.49a14.28,14.28,0,0,0,1.41,3.39,13.7,13.7,0,0,0,2.25,2.89C333.32,190,333.79,190.39,333.77,190.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.8,183a5.21,5.21,0,0,1-.86-.73,11.62,11.62,0,0,1-1.72-2.11,11.22,11.22,0,0,1-1.19-2.45,4.92,4.92,0,0,1-.3-1.09,9.32,9.32,0,0,1,.43,1,15.68,15.68,0,0,0,1.23,2.39,14.85,14.85,0,0,0,1.65,2.12A7.47,7.47,0,0,1,336.8,183Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.85,178.12s-.18-.42-.47-1.09a15.92,15.92,0,0,0-1.37-2.51,18.2,18.2,0,0,0-1.78-2.24c-.5-.54-.83-.86-.81-.88a4.84,4.84,0,0,1,.91.78,13.92,13.92,0,0,1,1.85,2.22,13,13,0,0,1,1.33,2.57c.13.35.22.63.28.83A1.24,1.24,0,0,1,343.85,178.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.22,174.39a10.52,10.52,0,0,1-.49-1.08,18.49,18.49,0,0,0-1.38-2.5,18.25,18.25,0,0,0-1.77-2.24,7.56,7.56,0,0,1-.8-.88,5.9,5.9,0,0,1,.91.78,14.65,14.65,0,0,1,1.83,2.23,14.19,14.19,0,0,1,1.34,2.55A4.62,4.62,0,0,1,352.22,174.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.21,174.73s-.12-.58-.38-1.51a14.08,14.08,0,0,0-1.49-3.41,13.85,13.85,0,0,0-2.35-2.89c-.7-.65-1.19-1-1.17-1a1.73,1.73,0,0,1,.36.22,10.41,10.41,0,0,1,.91.7,12.88,12.88,0,0,1,2.43,2.89,12.61,12.61,0,0,1,1.45,3.49,10.17,10.17,0,0,1,.21,1.12A2.19,2.19,0,0,1,362.21,174.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.63,169.4s-.2-.57-.65-1.43a9.63,9.63,0,0,0-5.61-4.71c-.92-.29-1.52-.34-1.52-.39a2.26,2.26,0,0,1,.43,0,6.22,6.22,0,0,1,1.13.22,9.15,9.15,0,0,1,5.7,4.79,6.7,6.7,0,0,1,.42,1.07A1.77,1.77,0,0,1,343.63,169.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.6,166.22s-.29-.51-.83-1.28a11.66,11.66,0,0,0-2.56-2.59,11.54,11.54,0,0,0-3.26-1.64c-.9-.28-1.48-.35-1.47-.39a1.41,1.41,0,0,1,.41,0,7,7,0,0,1,1.1.22,10.8,10.8,0,0,1,3.34,1.61,10.48,10.48,0,0,1,2.56,2.68,6.74,6.74,0,0,1,.55,1A1.61,1.61,0,0,1,352.6,166.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.11,166.06s0,.53,0,1.38a13.84,13.84,0,0,0,.56,3.24,13.58,13.58,0,0,0,1.35,3c.44.72.77,1.14.74,1.16s-.1-.09-.25-.27a8.78,8.78,0,0,1-.61-.81,11.54,11.54,0,0,1-1.42-3,11.71,11.71,0,0,1-.51-3.3,8.91,8.91,0,0,1,0-1C332.07,166.19,332.09,166.06,332.11,166.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.85,170.74a10.32,10.32,0,0,1,0,1.25,16,16,0,0,0,.28,3,17,17,0,0,0,.81,2.88c.28.72.48,1.15.45,1.16s-.07-.09-.18-.28a8,8,0,0,1-.4-.82,13.21,13.21,0,0,1-.89-2.9,14.29,14.29,0,0,1-.22-3c0-.39.05-.7.08-.92A1.24,1.24,0,0,1,328.85,170.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.79,182.21a6.38,6.38,0,0,0,3.77,1,1.94,1.94,0,0,0,.89-.2.91.91,0,0,0,.5-.73c0-.57-.64-.89-1.18-1.06a6.29,6.29,0,0,0,1.93-.31,2.1,2.1,0,0,0,1.32-1.36,1.41,1.41,0,0,0-.86-1.64A57.15,57.15,0,0,0,337.79,182.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.5,238.69s-27.26-38.69-31.08-41-8.95-1.18-12,.24c-2.09,1-6.86,3.95-6.86,3.95l-4.68-4.66-18.72,16.55,3.09,5.66-3.15,5.28c-.09.09-.2.21-.34.38a10.45,10.45,0,0,0-1.63,2.88l-.25.41.07.11a14.63,14.63,0,0,0-.72,5.17c.19,6.27,7,38.16,7,38.16l-7.12,4.86L360.37,290s21.09-7.08,20.58-14.14a197.63,197.63,0,0,0-3.51-20.93l9.84,13.32c.39,2.68,4.57,21.37,4.57,21.37l3,1.22,58.27-3.09,1.74-3.74Z",
    style: {
      fill: "#0072BC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.89,236.41a11.17,11.17,0,0,1,1.09,1.15c.66.76,1.61,1.89,2.76,3.3,2.29,2.82,5.37,6.78,8.72,11.19s6.33,8.45,8.47,11.39c1,1.42,1.85,2.59,2.5,3.49a8.8,8.8,0,0,1,.85,1.33,9.82,9.82,0,0,1-1-1.21l-2.63-3.4-8.59-11.29-8.6-11.28-2.63-3.39A7.93,7.93,0,0,1,362.89,236.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M434.57,246.2c-7.07,1-14.2-.41-21.25-1.45a236.59,236.59,0,0,0-35.47-2.52,5.48,5.48,0,0,0-3.1.63c-2.14,1.42-14.33,2.41-16.58,3.66l1.07,5.6c.17-.08,2.46.71,3.7.85,9.72,1.15,12.81-4.12,13.57-4.27,1.11-.21,2.5.8,3.55,1.19,7.67,2.82,15.73,4.37,23.75,5.91,6.65,1.28,13.39,2.56,20.13,2,3.12-.28,6.36-1,8.71-3.11S436.16,248.9,434.57,246.2Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M395.41,217l10.68,15.94-21.23-.84,1.18,15.7s36.58,8,42.16,6c6.34-2.2,6.06-5,6.44-8.62s-6.57-14.25-10.59-21.13-20.31-30.72-29-27.69C395,196.37,386.56,202.9,395.41,217Z",
    style: {
      fill: "#0072BC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.41,217l10.68,15.94-21.23-.84,1.18,15.7s36.58,8,42.16,6c6.34-2.2,6.06-5,6.44-8.62s-6.57-14.25-10.59-21.13",
    style: {
      fill: "#0072BC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.05,224.06s.08.09.2.28l.54.87,2.06,3.34c.89,1.45,2,3.22,3.19,5.31a70.61,70.61,0,0,1,3.8,7.3,20.87,20.87,0,0,1,.78,2.23,7.06,7.06,0,0,1,.2,1.22c0,.21,0,.43,0,.65l-.06.61a23.2,23.2,0,0,1-.32,2.54,6,6,0,0,1-1.1,2.47,10.33,10.33,0,0,1-4.72,3,8.46,8.46,0,0,1-2.92.45c-1,0-2,0-3-.1-4-.28-8.22-.9-12.54-1.59s-8.78-1.51-13.34-2.4Q391.28,249.16,386,248l-.18,0,0-.19c-.41-5.49-.8-10.75-1.16-15.7l0-.27h.26l21.22.9-.15.28-7.75-11.72-2.08-3.19-.53-.83a2,2,0,0,1-.17-.3,1.92,1.92,0,0,1,.21.27l.57.81,2.16,3.13,7.89,11.63.2.29h-.36l-21.23-.79.25-.25c.38,4.95.78,10.21,1.2,15.7l-.2-.22c3.51.75,7.14,1.49,10.84,2.21,4.55.89,9,1.71,13.32,2.42s8.49,1.31,12.49,1.61c1,.08,2,.12,2.95.11a8.18,8.18,0,0,0,2.78-.41,10,10,0,0,0,4.53-2.85c1.09-1.37,1.21-3.15,1.37-4.79a8.52,8.52,0,0,0-.88-4.53,72.38,72.38,0,0,0-3.71-7.3c-1.19-2.09-2.25-3.89-3.11-5.35l-2-3.39c-.2-.37-.37-.66-.49-.89S424.05,224.06,424.05,224.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M406.12,232.8A19.59,19.59,0,0,1,418,231.22a6.44,6.44,0,0,1,4,2.11c.33.44.53,1.11.12,1.47s-1.14.78-1.59.57a30.12,30.12,0,0,0-14.48-2.57"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M421.05,235.62c0,.08-.87-.37-2.3-.86a27.21,27.21,0,0,0-5.74-1.25c-2.29-.27-4.39-.33-5.91-.4a12.25,12.25,0,0,1-2.46-.18,10.64,10.64,0,0,1,2.46-.18,44.28,44.28,0,0,1,6,.25,21.71,21.71,0,0,1,5.81,1.42A7.1,7.1,0,0,1,421.05,235.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.38,271.32a22.75,22.75,0,0,0-5.74-.64A23.32,23.32,0,0,0,363,272a11.66,11.66,0,0,1,11.36-.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M363.1,271.84a13.79,13.79,0,0,1,8.07-3.22,5.07,5.07,0,0,1,3.19.66c.42.29.8.84.56,1.3s-1.06.45-1.65.31a16.53,16.53,0,0,0-10.16.81"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M394,196.49c.05.07-.6.44-1.33,1.33a8.75,8.75,0,0,0-1.79,4.06,17.07,17.07,0,0,0,0,4.53,9.09,9.09,0,0,1,.17,1.91,5.73,5.73,0,0,1-.52-1.86,13.37,13.37,0,0,1-.14-4.66,8,8,0,0,1,2-4.22A3.32,3.32,0,0,1,394,196.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.12,218.38a10.58,10.58,0,0,1-2.61-3.15,10.74,10.74,0,0,1-1.68-3.72A33.8,33.8,0,0,1,364,215,37.5,37.5,0,0,1,366.12,218.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372,214.66a15.64,15.64,0,0,1-3.17-3.33,15.32,15.32,0,0,1-2.49-3.86,30.93,30.93,0,0,1,2.89,3.54A31.4,31.4,0,0,1,372,214.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.13,209.93c-.14.07-1.05-1.78-2.72-3.64s-3.36-3-3.28-3.15A9.56,9.56,0,0,1,374.8,206,9.3,9.3,0,0,1,377.13,209.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.11,204.57a33.26,33.26,0,0,1-2.68-2.68,29.69,29.69,0,0,1-2.73-2.64,9.35,9.35,0,0,1,3.09,2.27A9.1,9.1,0,0,1,381.11,204.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M363.17,219.2a13.16,13.16,0,0,0,6.07-.56,22,22,0,0,0,5.25-2.83,18.64,18.64,0,0,0,5.74-5.92,17.45,17.45,0,0,0,1.94-6.54,19.3,19.3,0,0,0-3.19,4.38c-3.6,5.66-9.22,9.23-15.75,11.46"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M382.57,201.89a5.11,5.11,0,0,1-.41,1,24.58,24.58,0,0,1-1.43,2.61A34.36,34.36,0,0,1,374.4,213a29.64,29.64,0,0,1-8.24,5.3,14,14,0,0,1-1.59.59,11,11,0,0,1-1.24.36,5.08,5.08,0,0,1-1.07.19c0-.1,1.49-.44,3.75-1.47a32.5,32.5,0,0,0,8.05-5.36,38.57,38.57,0,0,0,6.36-7.3C381.81,203.24,382.48,201.84,382.57,201.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.81,259.13a3.48,3.48,0,0,1-.57.82c-.39.51-1,1.23-1.73,2.1-1.49,1.73-3.66,4.06-6.19,6.47s-5,4.45-6.8,5.86c-.91.7-1.65,1.25-2.18,1.62a4.94,4.94,0,0,1-.85.53,29.51,29.51,0,0,1,2.8-2.43c1.75-1.48,4.14-3.55,6.67-6s4.72-4.68,6.28-6.35A32.18,32.18,0,0,1,416.81,259.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.09,206.11a9.45,9.45,0,0,1-.92,1.34c-.61.86-1.56,2.05-2.79,3.48a73.59,73.59,0,0,1-23.13,17.86c-1.69.83-3.08,1.44-4.06,1.82a10.87,10.87,0,0,1-1.54.56,9,9,0,0,1,1.46-.74c.95-.43,2.32-1.1,4-2a83.88,83.88,0,0,0,12.31-7.86,82.7,82.7,0,0,0,10.71-9.93c1.25-1.38,2.24-2.54,2.9-3.35A9.64,9.64,0,0,1,390.09,206.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.25,219.84a8.84,8.84,0,0,1-1,1c-.69.63-1.71,1.52-3,2.61-2.55,2.17-6.15,5.08-10.25,8.13s-7.93,5.65-10.75,7.46c-1.41.91-2.55,1.62-3.36,2.1a8,8,0,0,1-1.28.7,7.8,7.8,0,0,1,1.17-.87l3.27-2.23c2.76-1.89,6.55-4.53,10.64-7.57s7.72-5.9,10.33-8l3.08-2.48A6.86,6.86,0,0,1,397.25,219.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.38,203.1a28,28,0,0,0-7.06,4,28.26,28.26,0,0,0-5.23,6.21,7.79,7.79,0,0,1,1.05-2.19,18.39,18.39,0,0,1,8.9-7.39A7.17,7.17,0,0,1,407.38,203.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.14,216.34c0,.08-1.13.27-2.92.72a38.72,38.72,0,0,0-13.06,6c-1.51,1.06-2.4,1.79-2.45,1.73s.17-.24.55-.6.95-.85,1.69-1.43a32.24,32.24,0,0,1,13.19-6c.91-.18,1.66-.29,2.18-.34A2.28,2.28,0,0,1,419.14,216.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.38,228.83c0,.08-1.28-.18-3.35-.35a32.84,32.84,0,0,0-15.82,2.58c-1.9.82-3,1.47-3.07,1.39a3.1,3.1,0,0,1,.74-.53,19.89,19.89,0,0,1,2.18-1.19,28.94,28.94,0,0,1,16-2.61,19.17,19.17,0,0,1,2.44.44A2.81,2.81,0,0,1,427.38,228.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.27,250.57a24.66,24.66,0,0,0-10.18-13.87,8.16,8.16,0,0,1,2.27,1.28,20.2,20.2,0,0,1,7.37,10A8.11,8.11,0,0,1,432.27,250.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.81,252.64c-.08,0,.26-1.1.59-2.87a27.79,27.79,0,0,0-.94-13.86c-.56-1.71-1-2.73-1-2.77a2.65,2.65,0,0,1,.42.68,16.17,16.17,0,0,1,.88,2,24.22,24.22,0,0,1,.95,14.06,16.25,16.25,0,0,1-.61,2.07C412,252.4,411.85,252.65,411.81,252.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.26,250.06a72.24,72.24,0,0,1-.8-8.54,71.6,71.6,0,0,1-.3-8.58,68.52,68.52,0,0,1,.81,8.54A72.74,72.74,0,0,1,400.26,250.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.65,238.78a15,15,0,0,1-3.79,1.16,15.27,15.27,0,0,1-3.92.65,16.16,16.16,0,0,1,3.8-1.15A15.53,15.53,0,0,1,364.65,238.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.3,254.13a10.27,10.27,0,0,1-2.32.62c-1.45.3-3.46.64-5.71.91s-4.29.39-5.77.43a9.68,9.68,0,0,1-2.4-.06,13.27,13.27,0,0,1,2.38-.3c1.47-.13,3.5-.32,5.73-.58s4.25-.55,5.71-.76A12.48,12.48,0,0,1,376.3,254.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380,267.44c0,.07-1-.43-2.52-1A21.07,21.07,0,0,0,364.7,266c-1.6.45-2.54.87-2.58.79s.21-.16.63-.38a14.1,14.1,0,0,1,1.85-.76,19,19,0,0,1,6.53-.91,18.72,18.72,0,0,1,6.43,1.41,12.15,12.15,0,0,1,1.79.9C379.75,267.25,380,267.41,380,267.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374,284c-.09,0-.24-1-.89-2.57a12.74,12.74,0,0,0-9.76-7.71c-1.65-.28-2.71-.18-2.71-.27a2.1,2.1,0,0,1,.73-.14,10.34,10.34,0,0,1,2,.05,12.19,12.19,0,0,1,10.05,7.93,10.55,10.55,0,0,1,.51,2A2,2,0,0,1,374,284Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.52,244.72a30.44,30.44,0,0,1-5,3.93,31,31,0,0,1-5.4,3.3,52.53,52.53,0,0,1,5.11-3.72A55,55,0,0,1,385.52,244.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.48,251a4.12,4.12,0,0,1-.71.65c-.48.39-1.19.94-2.08,1.59-1.79,1.32-4.32,3-7.22,4.77s-5.63,3.15-7.63,4.09c-1,.48-1.82.84-2.39,1.08a4,4,0,0,1-.92.32,30.46,30.46,0,0,1,3.15-1.72c1.95-1,4.63-2.48,7.52-4.21s5.45-3.39,7.28-4.62A27.29,27.29,0,0,1,404.48,251Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.08,262.65a3.49,3.49,0,0,1-.81.56c-.54.33-1.35.77-2.36,1.27a44.65,44.65,0,0,1-17.05,4.5c-1.13.06-2.05.08-2.68,0a4.08,4.08,0,0,1-1-.08c0-.08,1.39-.12,3.64-.33a56.51,56.51,0,0,0,8.64-1.54,55.49,55.49,0,0,0,8.27-2.93C410.81,263.24,412,262.58,412.08,262.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.35,255.07a7.28,7.28,0,0,1-1,.8c-.69.5-1.71,1.17-3,2a70.68,70.68,0,0,1-21.91,8.7c-1.48.31-2.69.52-3.53.63a6.68,6.68,0,0,1-1.31.13,6.06,6.06,0,0,1,1.27-.33c.83-.17,2-.43,3.49-.79a84.71,84.71,0,0,0,11.21-3.55,86.88,86.88,0,0,0,10.6-5.1c1.31-.75,2.36-1.37,3.08-1.82A6.61,6.61,0,0,1,440.35,255.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.67,268.53a3.26,3.26,0,0,1-.5.35l-1.47.91c-.64.39-1.43.86-2.37,1.36s-2,1.1-3.22,1.67-2.53,1.23-4,1.83-3,1.23-4.69,1.86a96.94,96.94,0,0,1-11.1,3.2,94.11,94.11,0,0,1-11.43,1.71c-1.78.12-3.46.26-5,.27s-3.05,0-4.4,0-2.55-.12-3.61-.18-2-.16-2.73-.25l-1.71-.22a2.36,2.36,0,0,1-.6-.11,4.05,4.05,0,0,1,.61,0l1.72.12c.75.06,1.66.13,2.72.16s2.27.12,3.61.1,2.8,0,4.38-.06,3.24-.18,5-.31a91.47,91.47,0,0,0,22.41-4.89c1.66-.61,3.24-1.17,4.68-1.8s2.79-1.2,4-1.77,2.28-1.12,3.23-1.6,1.76-.91,2.41-1.28l1.52-.82A2.12,2.12,0,0,1,446.67,268.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.66,283.64a2.73,2.73,0,0,1-.63.13l-1.83.26-6.73.86c-5.69.69-13.56,1.56-22.26,2.41s-16.6,1.49-22.32,1.91l-6.77.45-1.85.09a3.46,3.46,0,0,1-.64,0,3,3,0,0,1,.64-.1l1.83-.19,6.76-.61,22.3-2.06,22.27-2.26,6.75-.7,1.84-.17A2.82,2.82,0,0,1,454.66,283.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.63,259.06H282.19s-6,.95-6.13,5.81h11.73l13.1-2.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.1,268.34l-11.63-3L276.3,267s.27,5,6.1,5.28,17.93-.15,17.93-.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.2,243.67,302,259.48v11.76L350.29,284l1.91-5.83L307.36,267.8c-1.77-.65-2-1.37-2.1-3-.1-2.65,3.26-3.08,3.26-3.08l46.34-14.68,2.06-4.16Z",
    style: {
      fill: "#0072BC"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M352.2,243.67,302,259.48v11.76L350.29,284l1.91-5.83L307.36,267.8c-1.77-.65-2-1.37-2.1-3-.1-2.65,3.26-3.08,3.26-3.08l46.34-14.68,2.06-4.16Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M308.51,267.71H307.1a2.79,2.79,0,0,1-1.84-2.89c.08-2.8,3-2.8,3-2.8a2.26,2.26,0,0,0,0-4.52h-7.4a2.26,2.26,0,0,0,0,4.52H302v5.69h-.86a2.27,2.27,0,0,0,0,4.53h7.4a2.27,2.27,0,0,0,0-4.53Z",
    style: {
      fill: "#0072BC"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 301.64,
    cy: 270.19,
    r: 0.96,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.26,259.68a1,1,0,1,1-1-1A1,1,0,0,1,302.26,259.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.55,274.21h0a2.91,2.91,0,0,1-2.91-2.91V260.4a2.9,2.9,0,0,1,2.91-2.9h0a2.9,2.9,0,0,1,2.9,2.9v10.9A2.9,2.9,0,0,1,285.55,274.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.33,260.64a1,1,0,1,1-1-1A1,1,0,0,1,286.33,260.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 285.55,
    cy: 271.3,
    r: 1.01,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.38,436.93l5.28,17.16s-16,9.87-15.31,13.14l34-7.79-7.14-27.08Z",
    style: {
      fill: "#0072BC"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M460.67,449.83a1.44,1.44,0,0,1,1.38,1.32,1.38,1.38,0,0,1-1.29,1.37,1.51,1.51,0,0,1-1.45-1.4,1.42,1.42,0,0,1,1.5-1.28",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M469.31,459.44l-.72-2.73-32.53,8.66a2.41,2.41,0,0,0-.83,2.14Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M450.07,454.07c.05.16.89,0,1.84.32s1.57.89,1.7.78-.36-1-1.52-1.34S450,453.93,450.07,454.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.94,456.48c0,.17.79.25,1.53.8s1.11,1.23,1.27,1.18,0-1-.92-1.67S446.9,456.32,446.94,456.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.07,461.24c.16,0,.17-.89-.5-1.68s-1.53-.93-1.56-.78.57.51,1.11,1.17S445.9,461.27,446.07,461.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.3,450c.11.13.8-.3,1.75-.48s1.75-.09,1.8-.26-.81-.56-1.92-.32S449.19,449.91,449.3,450Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "449.48 450.24 450.41 453.3 465.95 446.72 465.31 444.28 449.48 450.24"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M448.3,446.54a3.19,3.19,0,0,0,1.68-.46,7.75,7.75,0,0,0,1.62-1,8.42,8.42,0,0,0,.83-.77,2.15,2.15,0,0,0,.4-.53.75.75,0,0,0-.16-.9.94.94,0,0,0-.82-.18,2.15,2.15,0,0,0-.61.26,6.06,6.06,0,0,0-.95.64A6,6,0,0,0,449,445c-.58.93-.69,1.61-.62,1.63s.33-.58,1-1.39a6.64,6.64,0,0,1,1.28-1.25,7,7,0,0,1,.88-.56c.34-.19.64-.28.77-.14s.06.07,0,.2a2.15,2.15,0,0,1-.3.39q-.37.41-.75.75a11.22,11.22,0,0,1-1.46,1.06A11.34,11.34,0,0,0,448.3,446.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.58,446.72a2.84,2.84,0,0,0,0-1.75,5.69,5.69,0,0,0-.72-1.78,5.9,5.9,0,0,0-.71-.91,1.42,1.42,0,0,0-1.3-.56.82.82,0,0,0-.58.66,2.46,2.46,0,0,0,0,.66,4.06,4.06,0,0,0,1.5,2.69c.89.69,1.63.7,1.63.64a12.44,12.44,0,0,1-1.36-1,4.12,4.12,0,0,1-1-1.44,3.8,3.8,0,0,1-.23-1c0-.37,0-.7.16-.7a1,1,0,0,1,.74.4,5.5,5.5,0,0,1,.66.8,6.63,6.63,0,0,1,.78,1.59C448.49,446.06,448.48,446.72,448.58,446.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.26,435.5l2.19,17.82s-17.48,6.91-17.39,10.24l34.8-1.7L398.59,434Z",
    style: {
      fill: "#0072BC"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.05,450.89a1.41,1.41,0,0,1,1.12,1.53,1.36,1.36,0,0,1-1.51,1.12,1.5,1.5,0,0,1-1.18-1.63,1.42,1.42,0,0,1,1.7-1",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M400.86,461.86l-.23-2.81-33.55,2.81a2.42,2.42,0,0,0-1.19,2Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M382.87,453.19c0,.17.87.17,1.75.65s1.39,1.14,1.54,1.06-.19-1-1.26-1.59S382.82,453,382.87,453.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.36,455c0,.17.73.4,1.37,1.06s.87,1.41,1,1.39.19-1-.62-1.8S379.35,454.85,379.36,455Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.67,459.55c.15,0,.32-.85-.2-1.74s-1.34-1.19-1.4-1,.48.6.89,1.34S377.5,459.55,377.67,459.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.82,449.08c.08.14.84-.16,1.81-.18s1.73.22,1.81.07-.7-.69-1.83-.66S382.73,449,382.82,449.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "382.95 449.13 383.34 452.31 399.79 448.56 399.55 445.62 382.95 449.13"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M382.44,445.47a3.25,3.25,0,0,0,1.74-.16,7.68,7.68,0,0,0,1.77-.71,8.64,8.64,0,0,0,1-.62,2.2,2.2,0,0,0,.48-.45.72.72,0,0,0,0-.91,1,1,0,0,0-.77-.33,2.71,2.71,0,0,0-.65.15,7.09,7.09,0,0,0-1,.46,6.06,6.06,0,0,0-1.52,1.2c-.74.81-1,1.47-.9,1.5s.43-.52,1.2-1.21a6.72,6.72,0,0,1,1.47-1,7,7,0,0,1,1-.4c.36-.13.68-.16.78,0s.05.08,0,.2a2,2,0,0,1-.36.33,7.54,7.54,0,0,1-.87.6,8.9,8.9,0,0,1-1.63.79A13.49,13.49,0,0,0,382.44,445.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.69,445.7A2.86,2.86,0,0,0,383,444a5.73,5.73,0,0,0-.4-1.89,5.21,5.21,0,0,0-.54-1,1.41,1.41,0,0,0-1.18-.78.77.77,0,0,0-.68.54,2.48,2.48,0,0,0-.13.66,4,4,0,0,0,1,2.9c.76.84,1.48,1,1.49.92s-.57-.36-1.16-1.18a3.94,3.94,0,0,1-.69-1.59,3.38,3.38,0,0,1-.06-1c0-.37.14-.68.28-.65s.49.23.65.51a5.58,5.58,0,0,1,.52.91,6.4,6.4,0,0,1,.48,1.7C382.72,445,382.59,445.68,382.69,445.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.7,434.4l-.76-3.57-12.77-64.58,3.67-56.4-3.67-22.09-33.92,1.8h0l-24.35,1.29s-20.47,71-21.82,74.71,6.27,84.38,6.27,84.38l21.51-4.6-.25-75L420,326.48l7.64,51.94,19,72.92,19.74-7.46-.57-4.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.11,298.07c.06,0,1.49,6.63,3.21,14.83s3.06,14.87,3,14.88-1.49-6.63-3.21-14.84S414.05,298.08,414.11,298.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453,297a9.87,9.87,0,0,1-2.7.68,12.58,12.58,0,0,1-6.61-1,12.75,12.75,0,0,1-5.16-4.25,9.63,9.63,0,0,1-1.3-2.46,6.87,6.87,0,0,1,.35.66,14.14,14.14,0,0,0,1.07,1.71,12.64,12.64,0,0,0,11.63,5.16,14,14,0,0,0,2-.36A5.33,5.33,0,0,1,453,297Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453,365.27c.05,0-1,3.8-2.36,8.45s-2.51,8.4-2.57,8.39,1-3.8,2.37-8.45S453,365.25,453,365.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401,368.16a4.24,4.24,0,0,1-.3.54l-.91,1.43c-.77,1.2-1.88,2.83-3.16,4.59s-2.5,3.32-3.4,4.43l-1.08,1.3a5.71,5.71,0,0,1-.42.46,3.94,3.94,0,0,1,.36-.51l1-1.34c.87-1.13,2.06-2.7,3.34-4.46s2.4-3.37,3.21-4.55l1-1.39A5.12,5.12,0,0,1,401,368.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.41,446.29s0-.46,0-1.34,0-2.19-.05-3.83c0-3.37-.1-8.18-.17-14.11-.12-11.95-.28-28.39-.46-46.56,0-1.59,0-3.17-.05-4.65v0h0a187.11,187.11,0,0,1,8.13-22.58c2.87-6.77,5.59-12.76,7.8-17.8s3.94-9.14,5.06-12c.58-1.41,1-2.53,1.28-3.28s.45-1.14.45-1.14-.55,1.59-1.66,4.45-2.8,7-5,12-4.9,11.05-7.76,17.82a191.63,191.63,0,0,0-8.1,22.56v0c0,1.47,0,3.06,0,4.65.16,18.17.3,34.61.41,46.56,0,5.93.07,10.74.1,14.11,0,1.64,0,2.92,0,3.83S396.41,446.29,396.41,446.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.47,290.32A8.61,8.61,0,0,1,401,293a10.66,10.66,0,0,1-6.52,10.32,8.4,8.4,0,0,1-2.58.7,5.5,5.5,0,0,1,.69-.18,12.68,12.68,0,0,0,1.83-.65A10.78,10.78,0,0,0,400.8,293a11.42,11.42,0,0,0-.2-1.92A4.93,4.93,0,0,1,400.47,290.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.81,293.14a1.19,1.19,0,0,1,.5-.15,2,2,0,0,1,1.36.38,1.82,1.82,0,0,1,.75,1.91,2.15,2.15,0,0,1-1.9,1.65,2.2,2.2,0,0,1-2.06-1.44,2,2,0,0,1,.4-2,2.31,2.31,0,0,1,1.22-.73,1.3,1.3,0,0,1,.52,0s-.18,0-.5.09a2.28,2.28,0,0,0-1.12.74,1.85,1.85,0,0,0-.34,1.87,2,2,0,0,0,1.87,1.3,2,2,0,0,0,1.72-1.48,1.66,1.66,0,0,0-.65-1.75,2,2,0,0,0-1.27-.42A4.48,4.48,0,0,0,416.81,293.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.72,233s-8.4-.88-10.1-.88-13.54,2.37-13.54,2.37-7.08,7-7,9.12l2.84-.46s-2.58,4.34-2.54,5.39-.27,2.35,1.24,2.67c2.63.56,3.8-2.41,3.8-2.41s-.27,1.46.79,1.71c1.57.37,3.41-.92,3.41-.92s.14,1.35,1.31,1.54a5.15,5.15,0,0,0,3.81-1.34,3,3,0,0,0,3.16-.07c1.7-1,3.81-4.73,3.81-4.73l2.23-.52,7.88,2.16Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.22,244.25a17.17,17.17,0,0,1-3.19,5,8.66,8.66,0,0,1,1.38-2.63A8.53,8.53,0,0,1,362.22,244.25Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.67,246.52c.11.08-.41,1-1.31,1.85s-1.79,1.39-1.87,1.28.65-.79,1.51-1.64S366.55,246.43,366.67,246.52Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.31,247.45c.13.05-.05.78-.6,1.51s-1.19,1.11-1.28,1,.37-.64.87-1.31S370.17,247.39,370.31,247.45Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.77,239.27c.06.06-.34.49-.88,1.24s-1.25,1.83-2,3.05c-1.43,2.47-2.39,4.58-2.52,4.52a15.86,15.86,0,0,1,2.07-4.77,19.15,19.15,0,0,1,2.13-3C359.24,239.57,359.73,239.23,359.77,239.27Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.42,276.69a10.05,10.05,0,0,1,4,1,4.41,4.41,0,0,1,2.4,3.22A2.86,2.86,0,0,1,362.7,284a3.37,3.37,0,0,1-2.74-1,5.86,5.86,0,0,1-1.41-6.32",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.55,278.06s-1-3.07-5.94-3c0,0-3.55.07-4,.41s-1.37,1.64-1.23,2.18a5.68,5.68,0,0,0,3.41,2.67c1.44.13,2.32-.07,2.66-.55S359.55,278.06,359.55,278.06Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.53,275.87c0-.06.43,0,1.06.29a3.33,3.33,0,0,1,1.92,1.9,1.86,1.86,0,0,1-1.06,2.42c-.71.27-1.16,0-1.13,0s.44,0,1-.3a1.57,1.57,0,0,0,.74-1.93,3.53,3.53,0,0,0-1.61-1.74C351.86,276.15,351.5,275.94,351.53,275.87Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.7,277.24c-.15,0-.27-.31-.43-.67s-.31-.66-.21-.76.48.1.68.56S353.83,277.24,353.7,277.24Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.76,280.09a3.66,3.66,0,0,1,1.89-1c.71-.06,1.52.49,1.44,1.2a4.06,4.06,0,0,1,.86-1.91,1.9,1.9,0,0,1,1.9-.63,1.27,1.27,0,0,1,.81,1.67,1.44,1.44,0,0,1,2.74.82c.07-.66,1-1,1.56-.67a2.48,2.48,0,0,1,1.14,1.56,7.48,7.48,0,0,1-2,8,3.36,3.36,0,0,1-1.75.86,1.72,1.72,0,0,1-1.69-.78,2,2,0,0,1-3.41.17,2.47,2.47,0,0,1-4.3-1.89,2.61,2.61,0,0,1-2.2.5,2,2,0,0,1-1-1.95,5.64,5.64,0,0,1,1.07-3.07,17.53,17.53,0,0,1,2.17-2.47",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.07,289.45a19.59,19.59,0,0,0,2-2.65,11.31,11.31,0,0,0,1.38-7.81v0a1.46,1.46,0,0,0-.76-.86,1.55,1.55,0,0,0-2,.63,2.79,2.79,0,0,0-.31,1.09,9.29,9.29,0,0,1-.16,1.21,10,10,0,0,1-1.65,3.87,9,9,0,0,1-1.93,2.05,3.12,3.12,0,0,1-.88.55,15,15,0,0,0,2.51-2.8,10.36,10.36,0,0,0,1.49-3.75,10.54,10.54,0,0,0,.13-1.16,3.07,3.07,0,0,1,.37-1.3,1.87,1.87,0,0,1,1.11-.93,2.19,2.19,0,0,1,1.49.07,2,2,0,0,1,1,1.19h0v0a11.3,11.3,0,0,1-1.58,8.09,10.34,10.34,0,0,1-1.59,1.92A2.77,2.77,0,0,1,355.07,289.45Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.77,279.26s-.08-.09,0-.26a.9.9,0,0,1,.57-.41,2,2,0,0,1,1.1-.07,1.82,1.82,0,0,1,1.11,1h0a8.84,8.84,0,0,1,.5,3.83,8.57,8.57,0,0,1-1.9,4.66,4.26,4.26,0,0,1-1.57,1.37c-.05-.06.56-.57,1.28-1.59a9.13,9.13,0,0,0,1.68-4.49,9.48,9.48,0,0,0-.4-3.64v0a1.53,1.53,0,0,0-.83-.78,1.71,1.71,0,0,0-.92,0C358.83,278.91,358.78,279.25,358.77,279.26Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.07,280.15a1.35,1.35,0,0,0-.76-.85c-.66-.29-1.68.24-2.63.94a27.65,27.65,0,0,0-3.06,3.1,7.35,7.35,0,0,1,2.75-3.52,6.81,6.81,0,0,1,1.57-.87,1.93,1.93,0,0,1,1.53,0,1.24,1.24,0,0,1,.65.8C355.17,280,355.1,280.16,355.07,280.15Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.61,283.84c-.07,0-.15-.35-.25-.9a6.79,6.79,0,0,0-.63-2,1.93,1.93,0,0,0-1.48-1.17c-.51,0-.76.24-.82.19s.13-.46.8-.55a2.1,2.1,0,0,1,1.95,1.28,4.92,4.92,0,0,1,.54,2.23C364.73,283.48,364.68,283.83,364.61,283.84Z",
    style: {
      fill: "#eb996e"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessDenied);
export default __webpack_public_path__ + "static/media/accessDenied.c9e6feeea737d8b6c147d01a0b228f24.svg";
export { ForwardRef as ReactComponent };